import _ from "lodash";
import baseAxios from "axios";
import moment from "moment";
import i18n, { t, changeLanguage } from "i18next";

import {
  setPolicies,
  setSelectedBadgeItemId,
  setBadgeSwitchItems,
  setFilterDates,
  setAvailableDates,
  setVideos,
  setTransStatus,
  setUnitFilters,
  setShowAllUnit,
  setSelfTourLink,
  setSelectedVideoSwitchId,
  setBedRooms,
  setBudgets,
  setBadgeSwitchVideos,
  updateFaq,
  setShowLangChange,
  setActiveOptionComp,
  addNewMessage,
  removeAndAddMessages,
  moveToTop,
  setReplies,
  setOptionsTypeLogs,
  filterEditMessages,
  setShowAllOptions,
  setLabelItems,
  setAllData,
  setAvailableSlots,
  setSelectedOptions,
  setSlotsLoading,
  loadInitialMessages,
  setShouldFetchSlots,
  setEntryId,
  setEmail,
  setConversationID,
  setAMAReply,
  setAMAResponse,
  setIsSpanishLanguage,
} from "slices";
import {
  WHEN_MOVE_IN_REPLIES,
  VISIT_RESIDENT_PORTAL_REPLIES,
  FORM_4_CONTACT_US_REPLIES,
  FORM_4_SCHEDULE_TOUR_REPLIES,
  POST_CONTACT_US_REPLIES,
  POST_SCHEDULE_TOUR_REPLIES,
  SHOW_ALL_UNITS_OPTION,
  SELF_TOUR_REPLIES,
  FAQS_REPLIES,
  FEEDBACK_TOUR_REPLIES,
  FEEDBACK_CONTACT_REPLIES,
  loaders,
  dotLoader,
  filterFaqOptions,
  INITIAL_REPLIES,
  INITIAL_REPLY_OPTIONS,
  EXPLORE_MORE_OPTION,
  defaultEditFormats,
  detectAndGenerateLinks,
  CUSTOM_BUTTON,
  DO_I_QUALIFY_REPLIES,
  textConstants,
  axios,
} from "utils";
import FriendlyBot from "components/Mascots/FriendlyBot";
import TheHayley from "components/Mascots/TheHayley";
import TheMinimalist from "components/Mascots/TheMinimalist";
import {
  APPOINTMENT_TYPES,
  CANCEL_TOUR_REPLIES,
  // chatData,
  compMsgKeys,
  DEFAULT_SESSION_ID,
  ERROR_MSG,
  filterRepliesByOptions,
  FOLLOW_UP_KEYS,
  FORM_4_CONTACT_US_OPTIONS,
  HAYLEY_EXTRA_OPTION_SOURCES,
  HAYLEY_MESSAGE_EDIT_TYPES,
  LANG_CHANGE_REPLIES,
  optionsBySubject,
  reportIds,
  RESCHEDULE_TOUR_REPLIES,
  SCHEDULE_TOUR_INQUIRIES,
  TOUR_MSGS_KEY,
} from "utils/constants/index";
import { setSearchResult } from "slices/units-slice/index";
import { restartMessagesWithLastOnly } from "slices/messages-slice/index";
import { setIsDisabled } from "slices/option-box-slice/index";
import { setTourAction, resetScheduleTourState } from "slices/schedule-tour-slice/index";

let store;

export const injectStore = (_store) => {
  store = _store;
};

export const getMascotManagement = (propertyId, apiKey) => {
  const state = store.getState();
  const isJAI = state.property.isJAI || "";

  if (isJAI) {
    return axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/properties/get_management?property_id=${propertyId}&api_key=${encodeURIComponent(apiKey)}&from=preview`
    );
  }

  return axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/properties/get_management?property_id=${propertyId}&api_key=${encodeURIComponent(apiKey)}&from=property_website`
  );
};

export const updateLanguage = (propertyId, apiKey, isSpanish) => {
  return axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/properties/update_haylay_language?property_id=${propertyId}&api_key=${encodeURIComponent(
      apiKey
    )}&set_spanish_language=${isSpanish}`
  );
};

export const getPromotionInfo = (propertyId, apiKey) => {
  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/properties/promotion_info?api_key=${encodeURIComponent(apiKey)}&property_id=${propertyId}`);
};

export const getPrivacyPolicyDisclaimer = (orgId) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", "myhyly-hyblast-sync");
  myHeaders.append("Content-Type", "application/json");

  const graphql = JSON.stringify({
    query: `
        query ($orgId: ID!) {
          privacyPolicyDisclaimer(orgId: $orgId) {
            disclaimer
            disclaimerEnabled
          }
        }
      `,
    variables: {
      orgId: String(orgId),
    },
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow",
  };

  return fetch(`${process.env.REACT_APP_CRM_BASE_URL}/graphql`, requestOptions);
};

export const fetchPropertyData = (propertyId) => {
  return baseAxios.get(`${process.env.REACT_APP_API_BASE_URL}/properties/api_token?property_id=${propertyId}`);
};

export const getBedroomTypes = (queryParams) => {
  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/apartments/bedroom_types${queryParams}`);
};

export const getPriceBrackets = (queryParams) => {
  const queryString = getFirstBedroomTypeQuery(queryParams);

  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/apartments/price_brackets${queryString}`);
};

export const getMoveInDates = (queryParams) => {
  const queryString = getFirstBedroomTypeQuery(queryParams);

  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/apartments/time_options${queryString}`);
};

export const getUnits = (queryParams) => {
  const filterQueryParams = (params) => {
    const urlParams = new URLSearchParams(params);

    const bedroomType = urlParams.get("bedroom_type");

    if (bedroomType) {
      urlParams.delete("bedroom_type");
    }

    // Add JSON-style array format if valid
    if (bedroomType && bedroomType !== "all") {
      const types = bedroomType.startsWith("[") ? JSON.parse(bedroomType) : [bedroomType];
      const jsonArray = JSON.stringify(types.map((type) => type.trim()));
      urlParams.append("bedroom_type", jsonArray);
    }

    // Add buffers if desired_move_in is present
    if (urlParams.get("desired_move_in")) {
      urlParams.append("lower_buffer", 10);
      urlParams.append("upper_buffer", 10);
    }

    return urlParams.toString();
  };

  const filteredParams = filterQueryParams(queryParams);

  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/properties/find_apartments?${filteredParams}&per_page=100`);
};

export const getFloorPlans = (queryParams) => {
  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/properties/floor_plans${queryParams}`);
};

export const getMoveInOptions = (queryParams) => {
  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/apartments/move_in_options${queryParams}`);
};

export const getResidentPortalLink = (queryParams) => {
  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/apartments/user_portal${queryParams}`);
};

export const getAvailableDates = (queryParams) => {
  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/properties/tour_availability${queryParams}`);
};

export const getAvailableTimes = (queryParams) => {
  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/properties/tour_availability${queryParams}`);
};

export const createNewContact = (data) => {
  return axios.post(`${process.env.REACT_APP_API_BASE_URL}/contacts`, data);
};

export const scheduleTour = (data) => {
  return axios.post(`${process.env.REACT_APP_API_BASE_URL}/properties/tour_confirmation`, data);
};

export const findUserEntry = (queryParams) => {
  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/contacts/find_entry${queryParams}`);
};

export const getGallery = (queryParams) => {
  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/properties/images${queryParams}`);
};

export const getPolicies = (queryParams) => {
  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/properties/policy${queryParams}`);
};

export const getSelfTourLink = (queryParams) => {
  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/properties/get_tour_url${queryParams}`);
};

export const getFAQsReply = (data) => {
  return axios.post(`${process.env.REACT_APP_WS_BASE_URL}`, data);
};

// mockApi.js

// export const getFAQsReply = (data) => {
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve({
//         data: chatData,
//       });
//     }, 500); // Simulate API delay
//   });
// };

export const getVideos = (queryParams) => {
  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/properties/videos${queryParams}`);
};

function updateApartmentContext(propertyId, options) {
  const apartmentContextKey = `${propertyId}-context`;
  const apartmentContext = localStorage.getItem(apartmentContextKey);

  if (!!apartmentContext) {
    const appContext = JSON.parse(apartmentContext);

    if (appContext?.length > 0) {
      const { desiredMoveIn, bedroomType, priceRange } = options;

      if (desiredMoveIn) {
        appContext[0].desiredMoveInDate = desiredMoveIn;
      }

      if (bedroomType) {
        appContext[0].bedroomPreference = bedroomType;
      }

      if (priceRange) {
        appContext[0].priceRange = priceRange;
      }

      localStorage.setItem(apartmentContextKey, JSON.stringify(appContext));
    }
  }
}

//Global cancel option
const CANCEL_OPTION = {
  content: {
    component: "NormalOptionTile",
    componentOptions: {
      icon: "",
      label: "cancel",
    },
  },
  nextOptionsType: "Cancel",
  message: [
    {
      message: "cancel",
      speaker: "user",
    },
  ],
  key: "cancel",
  disablePlaceholerMessage: false,
  data: null,
};

const scheduleTourFormInfo = (props) => {
  const { skip, isPhoneNumberRequired } = props;

  return new Promise((resolve, reject) => {
    const updatedContactUsOptions = updatePhoneNumberOptional(FORM_4_SCHEDULE_TOUR_REPLIES.options, isPhoneNumberRequired);

    const updatedContactUsReplies = {
      ...FORM_4_SCHEDULE_TOUR_REPLIES,
      options: updatedContactUsOptions,
    };
    resolve({ data: updatedContactUsReplies, skip: skip });
  });
};

const scheduleTourAvailableTimesInfo = (props) => {
  const { appointmentType, propertyId, encodedApiKey, date, skip } = props;

  return new Promise((resolve, reject) => {
    if (!appointmentType) {
      reject("No appointment type!");

      return;
    }

    getAvailableTimes(`?property_id=${propertyId}&api_key=${encodedApiKey}&date=${date}&tour_type=${appointmentType}`)
      .then((res) => {
        resolve({
          data: res.data.map((d) => d.time_slot),
          extraData: date,
          skip: skip,
        });
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const allUnitsInfo = (props) => {
  const { priceRange, propertyId, encodedApiKey, bedroomType, desiredMoveIn, skip } = props;
  const state = store.getState();
  const appSSID = state.window.appSSID || "";

  return new Promise((resolve, reject) => {
    store.dispatch(
      setUnitFilters({
        bedrooms: bedroomType,
        budgets: priceRange,
        moveIns: desiredMoveIn || "any",
      })
    );

    const length = priceRange?.length || 0;

    const min = length === 0 ? null : length > 1 ? priceRange[0] : 0;
    const max = length === 0 ? null : length > 1 ? priceRange[1] : priceRange[0];

    let convertedDate = desiredMoveIn;

    if (moment(desiredMoveIn, "MMM DD, YYYY", true).isValid()) {
      convertedDate = moment(desiredMoveIn, "MMM DD, YYYY").format("YYYY-MM-DD");
    }

    const isPriceFilter = store.getState().property.isPriceFilter;
    let queryParams = `?property_id=${propertyId}&api_key=${encodedApiKey}${bedroomType ? `&bedroom_type=${bedroomType}` : ""}${
      desiredMoveIn ? `&desired_move_in=${convertedDate || desiredMoveIn}` : ""
    }`;

    if (isPriceFilter) {
      queryParams = `?property_id=${propertyId}&api_key=${encodedApiKey}${bedroomType ? `&bedroom_type=${bedroomType}` : ""}${
        desiredMoveIn ? `&desired_move_in=${convertedDate || desiredMoveIn}` : ""
      }${min ? `&min_price=${min}` : ""}${max ? `&max_price=${max}` : ""}`;
    }

    store.dispatch(setShowAllUnit(false));

    updateApartmentContext(propertyId, {
      desiredMoveIn: convertedDate || desiredMoveIn,
      bedroomType: bedroomType,
      priceRange: priceRange,
    });

    getUnits(queryParams)
      .then((res) => {
        if (!res.data) {
          const requestOption = {
            tag: "NO_FLOOR_PLAN_SHOWED",
            metric: "Surprise",
            propertyId: propertyId,
            sessionId: appSSID,
            appSubsection: "No floor plan showed",
          };
          createEventSignal(requestOption);
        }

        store.dispatch(setSearchResult(res?.data?.search_result || false));

        resolve({
          data: res.data || {},
          extraData: {
            enableExtraOption: !_.isEmpty(desiredMoveIn) && !_.isEmpty(priceRange),
          },
          skip: skip,
        });
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getRightInfoForAvailableDates = (context, propertyId, encodedApiKey, appointmentType, isPhoneNumberRequired) => {
  if (!context?.preferredTime && context?.preferredDate) {
    const date = context.preferredDate;
    const formattedDate = date.replace(/^\.*/, "");

    return scheduleTourAvailableTimesInfo({
      date: formattedDate,
      propertyId: propertyId,
      encodedApiKey: encodedApiKey,
      appointmentType: appointmentType,
      skip: "preferredDate",
    });
  } else if (context?.preferredTime && context.preferredDate) {
    return scheduleTourFormInfo({ skip: "confirmation", isPhoneNumberRequired: isPhoneNumberRequired });
  }
};

const getApartmentRightInfo = (context, propertyId, encodedApiKey) => {
  let bedroomType = `${context?.bedroomPreference}`;

  if (context?.bedroomPreference && (!context?.desiredMoveInDate || !context?.priceRange)) {
    if (context?.bedroomPreference === "studio") {
      bedroomType = "studio";
    }

    const isPriceFilter = store.getState().property.isPriceFilter;

    if (isPriceFilter && !context?.priceRange) {
      if (bedroomType) {
        return new Promise((resolve, reject) => {
          getPriceBrackets(`?property_id=${propertyId}&api_key=${encodedApiKey}&bedroom_type=${bedroomType}`).then((res) => {
            if (!res.data || Object.keys(res.data).length === 0) {
              resolve({
                data: {
                  _custom_price_range: [100, 5000],
                  _form_desired_price_range: [],
                },
                skip: "bedroomType",
              });
            }

            resolve({ data: res.data, skip: "bedroomType" });
          });
        });
      }

      return new Promise((resolve) => {
        getPriceBrackets(`?api_key=${encodedApiKey}&property_id=${propertyId}`).then((res) => {
          if (!res.data || Object.keys(res.data).length === 0) {
            resolve({
              data: {
                _custom_price_range: [100, 5000],
                _form_desired_price_range: [],
              },
            });
          }

          resolve({ data: res.data });
        });
      });
    }

    if (!context?.desiredMoveInDate) {
      return new Promise((resolve, reject) => {
        getMoveInDates(`?property_id=${propertyId}&api_key=${encodedApiKey}&bedroom_type=${bedroomType}`).then((res) => {
          const options = filterRepliesByOptions(WHEN_MOVE_IN_REPLIES, res?.data);
          resolve({ data: options, skip: "getPriceRange" });
        });
      });
    }
  } else if (context?.priceRange && !context?.desiredMoveInDate) {
    return new Promise((resolve, reject) => {
      getMoveInDates(`?property_id=${propertyId}&api_key=${encodedApiKey}&bedroom_type=${bedroomType}`).then((res) => {
        const options = filterRepliesByOptions(WHEN_MOVE_IN_REPLIES, res?.data);
        resolve({ data: options, skip: "getPriceRange" });
      });
    });
  } else if (context?.desiredMoveInDate) {
    const desiredMoveIn = context?.desiredMoveInDate.replace(/^\.*/, "");
    const price = context?.priceRange;
    let priceRange = "";

    if (price) {
      priceRange = price;
    }

    let bedroomType = parseInt(context?.bedroomPreference) <= 1 ? `${context?.bedroomPreference}-bedroom` : `${context?.bedroomPreference}-bedrooms`;

    if (context?.bedroomPreference === "studio") {
      bedroomType = "studio";
    }

    return allUnitsInfo({
      propertyId: propertyId,
      encodedApiKey: encodedApiKey,
      priceRange: priceRange,
      bedroomType: bedroomType,
      desiredMoveIn: desiredMoveIn,
      skip: "DesiredMoveInDate",
    });
  }

  return Promise.resolve({
    data: [],
    skip: "noConditionMatched",
  });
};

const getRightInfoForApartment = (context, propertyId, encodedApiKey, getPriceRange, bedroomType, moveIn) => {
  const isPriceFilter = store.getState().property.isPriceFilter;

  if (isPriceFilter && !context?.priceRange && !getPriceRange) {
    const queryParams = new URLSearchParams({
      property_id: propertyId,
      api_key: encodedApiKey,
      ...(bedroomType && { bedroom_type: bedroomType }),
    });

    return new Promise((resolve, reject) => {
      getPriceBrackets(`?${queryParams}`).then((res) => {
        if (!res.data || Object.keys(res.data).length === 0) {
          resolve({
            data: {
              _custom_price_range: [100, 5000],
              _form_desired_price_range: [],
            },
          });
        }

        resolve({ data: res.data });
      });
    });
  }

  if (!context?.desiredMoveInDate && !moveIn) {
    return new Promise((resolve, reject) => {
      getMoveInDates(`?property_id=${propertyId}&api_key=${encodedApiKey}&bedroom_type=${bedroomType}`).then((res) => {
        const options = filterRepliesByOptions(WHEN_MOVE_IN_REPLIES, res?.data);
        resolve({ data: options, skip: "getPriceRange" });
      });
    });
  }

  const desiredMoveIn = context?.desiredMoveInDate || moveIn;
  const price = getPriceRange || context?.priceRange;
  let priceRange = "";

  if (price) {
    priceRange = price;
  }

  return allUnitsInfo({
    propertyId: propertyId,
    encodedApiKey: encodedApiKey,
    priceRange: priceRange,
    bedroomType: bedroomType,
    desiredMoveIn: desiredMoveIn,
    skip: "DesiredMoveInDate",
  });
};

const updatePhoneNumberOptional = (options, isPhoneNumberRequired) => {
  return options.map((option) => {
    if (option.key === "phone") {
      return {
        ...option,
        content: {
          ...option.content,
          componentOptions: {
            ...option.content.componentOptions,
            isOptional: !isPhoneNumberRequired,
          },
        },
        isRequired: isPhoneNumberRequired ? true : false,
      };
    }

    return option;
  });
};

// function areFloorPlansValid(floorplans) {
//   if (!Array.isArray(floorplans) || floorplans.length === 0) {
//     return false;
//   }

//   for (const fp of floorplans) {
//     const hasValidUnitsCount = typeof fp.units_count === "number" && fp.units_count > 0;
//     const hasValidUnitsArray = Array.isArray(fp.units) && fp.units?.length > 0;

//     if (!hasValidUnitsCount || !hasValidUnitsArray) {
//       return false;
//     }
//   }

//   return true;
// }

export const getNextOptions = (optionType, data, isAMA, context, available_tourTypes, customButtonId, isAsap, photos) => {
  const state = store.getState();
  const isPhoneNumberRequired = state.property.isPhoneNumberRequired;
  const propertyId = state.property.property_id || "";
  const appSSID = state.window.appSSID || "";
  const apiKey = state.property.api_key || "";
  const encodedApiKey = encodeURIComponent(apiKey);
  const customButtonData = store.getState().property.customButtons;
  /** Extra query params for getting filtered out units data */
  const bedroomType = state.params.label.bedroom_type || "";
  const desiredMoveIn = state.params.label.desired_move_in || "";
  const price = state.params.label.price || "";
  let priceRange = "";
  /** Split price into min and max value */

  if (price) {
    priceRange = price;
  }

  /** Inputted user info */
  const userEmail = state.params.label.email || "";
  const phoneNumber = state.params.label.phone_number || state.params.label.phone || "";
  const firstName = state.params.label.first_name || "";
  const lastName = state.params.label.last_name || "";
  const appointmentType = state.params.label.appointment_type || state.scheduleTour.selectedOptions.tourType || "";
  const custom_questions = state.params.label.custom_questions || null;
  const allMessages = store.getState().messages.messages || [];
  const orgId = store.getState().property.org_id || "";
  const conversationID = store.getState().window.conversationID || "";
  const enabledScheduleTour = store.getState().property.enabled_schedule_a_tour || false;

  const amaResponse = state.replies.amaResponse || null;
  const isMultiLanguageEnabled = state.property.isMultiLanguage || false;
  const isSpanishCurrentLanguage = state.property.isSpanishLanguage || false;
  const bookingId = localStorage.getItem(`${propertyId}-bookingId`) || "";
  const usersFaqMsg = localStorage.getItem(`${propertyId}-userFaq-msg`) || "";
  const storedContext = localStorage.getItem(`${propertyId}-context`);
  const entryId = localStorage.getItem(`${propertyId}-entry_id`) || "";
  const localStorageContext = JSON.parse(storedContext) || [];

  const { tourType: selectedTourType, time: selectedTourTime } = state.scheduleTour.selectedOptions;

  const checkCustomQues = custom_questions ? { custom_questions } : {};
  const urlParams = new URLSearchParams(window.location.search);
  const isJAI = urlParams.get("isjai");
  const date = state.params.label.date || "";

  if (context?.length > 0) {
    localStorage.setItem(`${propertyId}-context`, JSON.stringify(context));
  }

  switch (optionType) {
    case "BedroomTypes": {
      if (context?.length > 0 && context[0]?.bedroomPreference) {
        return getApartmentRightInfo(context[0], propertyId, encodedApiKey, price);
      }

      return getBedroomTypes(`?api_key=${encodedApiKey}&property_id=${propertyId}`);
    }
    case "PriceBrackets": {
      const apartment_context = localStorage.getItem(`${propertyId}-context`);

      if (!!apartment_context) {
        const appContext = JSON.parse(apartment_context);

        if (appContext?.length > 0) {
          return getRightInfoForApartment(appContext[0], propertyId, encodedApiKey, priceRange, bedroomType, desiredMoveIn);
        }
      }

      if (bedroomType) {
        return new Promise((resolve) => {
          getPriceBrackets(`?property_id=${propertyId}&api_key=${encodedApiKey}&bedroom_type=${bedroomType}`).then((res) => {
            if (!res.data || Object.keys(res.data).length === 0) {
              resolve({
                data: {
                  _custom_price_range: [100, 5000],
                  _form_desired_price_range: [],
                },
              });
            }

            resolve({ data: res.data });
          });
        });
      }

      return new Promise((resolve) => {
        getPriceBrackets(`?api_key=${encodedApiKey}&property_id=${propertyId}`).then((res) => {
          if (!res.data || Object.keys(res.data).length === 0) {
            resolve({
              data: {
                _custom_price_range: [100, 5000],
                _form_desired_price_range: [],
              },
            });
          }

          resolve({ data: res.data });
        });
      });
    }

    case "noLangChange": {
      store.dispatch(setReplies(INITIAL_REPLIES));

      setTimeout(() => {
        handleAMAResponse(amaResponse, true);
      }, 600);

      return Promise.resolve({ skipHandleSuccess: true });
    }

    case "yesLangChange": {
      store.dispatch(setReplies(INITIAL_REPLIES));

      const history = getLastConversations(allMessages, 5)
        ?.map((i) => ({
          role: i.speaker === "bot" || i.speaker === "faqBot" ? "assistant" : "user",
          content: i.message,
        }))
        .filter((i) => i.content && i.content.trim() !== "");

      const faqReply = {
        history,
        propertyId,
        orgId: orgId,
        booking_id: bookingId,
        message: usersFaqMsg + " Please reply me in spanish.",
        conversation_id: conversationID,
        session_id: appSSID || DEFAULT_SESSION_ID,
        graphql_api_key: encodedApiKey,
        tourScheduleEnabled: enabledScheduleTour,
        spanish_support_enabled: !!isMultiLanguageEnabled,
        spanish_toggle: true,
      };

      const langChangeAndApiCall = new Promise((resolve, reject) => {
        changeLanguage("sp")
          .then(() => {
            store.dispatch(setIsSpanishLanguage(true));
            store.dispatch(addNewMessage([{ message: "I now support Spanish too!", speaker: "bot", createdAt: new Date().toISOString() }]));

            return getFAQsReply(faqReply);
          })
          .then((res) => {
            // Execute handleAMAResponse with the API response.
            handleAMAResponse(res, true);
            resolve({ skipHandleSuccess: true }); // Resolve the main promise
          })
          .catch((err) => {
            store.dispatch(removeAndAddMessages([{ message: ERROR_MSG, speaker: "bot", subject: "", createdAt: new Date() }]));
            store.dispatch(setIsDisabled(false));
            reject(err);
          });
      });

      return langChangeAndApiCall;
    }

    case "cancelTour":
    case "noDoNotCancel": {
      const history = getLastConversations(allMessages, 5)
        ?.map((i) => ({
          role: i.speaker == "bot" || i.speaker == "faqBot" ? "assistant" : "user",
          content: i.message,
        }))
        .filter((i) => i.content && i.content.trim() !== "");

      const faqReply = {
        history,
        propertyId,
        orgId: orgId,
        booking_id: bookingId,
        message: TOUR_MSGS_KEY[optionType],
        conversation_id: conversationID,
        session_id: appSSID || DEFAULT_SESSION_ID,
        graphql_api_key: encodedApiKey,
        tourScheduleEnabled: enabledScheduleTour,
        spanish_support_enabled: !!isMultiLanguageEnabled,
        spanish_toggle: !!isSpanishCurrentLanguage,
      };

      return getFAQsReply(faqReply);
    }
    case "WhenMoveIn": {
      const apartmentContextM = localStorage.getItem(`${propertyId}-context`);

      if (!!apartmentContextM) {
        const appContext = JSON.parse(apartmentContextM);

        if (appContext?.length > 0 && appContext[0]?.desiredMoveInDate) {
          localStorage.removeItem(`${propertyId}-context`);

          return getRightInfoForApartment(appContext[0], propertyId, encodedApiKey, priceRange, bedroomType);
        }
      }

      return new Promise((resolve, reject) => {
        getMoveInDates(`?property_id=${propertyId}&api_key=${encodedApiKey}&bedroom_type=${bedroomType}`)
          .then((res) => {
            const options = filterRepliesByOptions(WHEN_MOVE_IN_REPLIES, res?.data);
            resolve({ data: options });
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
    case "Units":
      return new Promise((resolve, reject) => {
        store.dispatch(
          setUnitFilters({
            bedrooms: bedroomType,
            budgets: priceRange,
            moveIns: desiredMoveIn || "any",
          })
        );

        const length = priceRange?.length || 0;

        const min = length === 0 ? null : length > 1 ? priceRange[0] : 0;
        const max = length === 0 ? null : length > 1 ? priceRange[1] : priceRange[0];

        let convertedDate = desiredMoveIn;
        let alreadyDots = false;

        if (moment(desiredMoveIn, "MMM DD, YYYY", true).isValid()) {
          convertedDate = moment(desiredMoveIn, "MMM DD, YYYY").format("YYYY-MM-DD");
        }

        if (desiredMoveIn?.includes("..") || convertedDate?.includes("..")) {
          alreadyDots = true;
        }

        const queryParams = `?property_id=${propertyId}&api_key=${encodedApiKey}${bedroomType ? `&bedroom_type=${bedroomType}` : ""}${
          desiredMoveIn ? `&desired_move_in=${!alreadyDots ? "..." + convertedDate || desiredMoveIn : convertedDate || desiredMoveIn}` : ""
        }${min ? `&min_price=${min}` : ""}${max ? `&max_price=${max}` : ""}`;

        updateApartmentContext(propertyId, {
          desiredMoveIn: convertedDate || desiredMoveIn,
          bedroomType: bedroomType,
          priceRange: priceRange,
        });

        store.dispatch(setShowAllUnit(false));

        getUnits(queryParams)
          .then((res) => {
            if (!res.data) {
              const requestOption = {
                tag: "NO_FLOOR_PLAN_SHOWED",
                metric: "Surprise",
                propertyId: propertyId,
                sessionId: appSSID,
                appSubsection: "No floor plan showed",
              };
              createEventSignal(requestOption);
            }

            store.dispatch(setSearchResult(res?.data?.search_result || false));

            resolve({
              data: res.data || {},
              extraData: {
                enableExtraOption: !_.isEmpty(desiredMoveIn) && !_.isEmpty(price),
              },
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    case "UnitsByRoom":
      return new Promise((resolve, reject) => {
        if (_.isEmpty(bedroomType)) {
          resolve({
            data: [],
            extraData: {
              enableExtraOption: !_.isEmpty(desiredMoveIn) && !_.isEmpty(price),
            },
          });
        }

        // const queryParams = `?property_id=${propertyId}&api_key=${encodedApiKey}&bedroom_type=${bedroomType}`;
        const queryParamsObj = new URLSearchParams({
          property_id: propertyId,
          api_key: encodedApiKey,
        });

        // Ensure bedroomType is always treated as an array
        const bedroomTypeArray = Array.isArray(bedroomType) ? bedroomType : [bedroomType];

        // Append each bedroom type as array-style query param
        bedroomTypeArray.forEach((type) => {
          queryParamsObj.append("bedroom_type[]", type);
        });

        const queryParams = queryParamsObj.toString();
        store.dispatch(setShowAllUnit(true));

        updateApartmentContext(propertyId, {
          bedroomType: bedroomType,
        });

        getUnits(queryParams)
          .then((res) => {
            if (!res.data) {
              const requestOption = {
                tag: "NO_FLOOR_PLAN_SHOWED",
                metric: "Surprise",
                propertyId: propertyId,
                sessionId: appSSID,
                appSubsection: "No floor plan showed",
              };
              createEventSignal(requestOption);
            }

            store.dispatch(setSearchResult(res?.data?.search_result || false));

            resolve({
              data: res.data || {},
              extraData: {
                enableExtraOption: !_.isEmpty(desiredMoveIn) && !_.isEmpty(price),
              },
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    case "UnitsAll":
      store.dispatch(setShowAllUnit(true));
      store.dispatch(setUnitFilters(null));

      return getUnits(`?api_key=${encodedApiKey}&property_id=${propertyId}`);
    case "rescheduleFromTourStatus":
    case "ScheduleTour":
      if (!state.property.enabled_schedule_a_tour) {
        return new Promise((resolve, reject) => {
          const updatedContactUsOptions = updatePhoneNumberOptional(FORM_4_SCHEDULE_TOUR_REPLIES.options, isPhoneNumberRequired);

          const updatedContactUsReplies = {
            ...FORM_4_SCHEDULE_TOUR_REPLIES,
            options: updatedContactUsOptions,
          };
          resolve({ data: updatedContactUsReplies });
        });
      }

      if (context?.length > 0) {
        localStorage.setItem(`${propertyId}-context`, JSON.stringify(context));
      }

      if (context?.length > 0 && context[0]?.tourType) {
        return scheduleTourFormInfo({ skip: "confirmation", isPhoneNumberRequired });
      }

      return new Promise((resolve, reject) => {
        getSelfTourLink(`?api_key=${encodedApiKey}&property_id=${propertyId}`)
          .then((res) => {
            const self_tour_link = res.data;
            store.dispatch(setSelfTourLink(self_tour_link));
            const updatedContactUsOptions = updatePhoneNumberOptional(FORM_4_SCHEDULE_TOUR_REPLIES.options, isPhoneNumberRequired);

            const updatedContactUsReplies = {
              ...FORM_4_SCHEDULE_TOUR_REPLIES,
              options: updatedContactUsOptions,
            };
            resolve({ data: updatedContactUsReplies });
          })
          .catch((err) => {
            reject(err);
          });
      });
    case "AvailableDates4PersonTour":
    case "AvailableDates4VideoTour":
    case "AvailableDatesForSelfTour": {
      const contextItem = localStorage.getItem(`${propertyId}-context`);
      let tourContext = null;

      if (!!contextItem) {
        tourContext = JSON.parse(contextItem);

        if (tourContext?.length > 0 && tourContext[0]?.preferredDate) {
          localStorage.removeItem(`${propertyId}-context`);

          return getRightInfoForAvailableDates(tourContext[0], propertyId, encodedApiKey, appointmentType, isPhoneNumberRequired);
        }
      }

      return getAvailableDates(`?property_id=${propertyId}&api_key=${encodedApiKey}&appointmentType=${appointmentType}`);
    }
    case "AvailableTimes": {
      const contextTourType = localStorage.getItem(`${propertyId}-context`);
      let tourContextType = null;

      if (!!contextTourType) {
        tourContextType = JSON.parse(contextTourType);

        return scheduleTourAvailableTimesInfo({
          date: date,
          propertyId: propertyId,
          encodedApiKey: encodedApiKey,
          appointmentType: tourContextType[0].tourType,
        });
      }

      return scheduleTourAvailableTimesInfo({ date: date, propertyId: propertyId, encodedApiKey: encodedApiKey, appointmentType: appointmentType });
    }
    case "Form4ScheduleTour":
      return scheduleTourFormInfo({ skip: "", isPhoneNumberRequired: isPhoneNumberRequired });
    case "LikeTour":
    case "DisLikeTour":
    case "SkipTour": {
      const data = filterFaqOptions(POST_SCHEDULE_TOUR_REPLIES);

      return new Promise((resolve, reject) => {
        resolve({ data, extraData: { botMessages: ["whatNext"] } });
      });
    }
    case "LikeContact":
    case "DisLikeContact":
    case "SkipContact": {
      const msg = ["whatNext"];
      const data = filterFaqOptions(POST_CONTACT_US_REPLIES);

      return new Promise((resolve, reject) => {
        resolve({ data, extraData: { botMessages: msg } });
      });
    }
    case "PostScheduleTour": {
      const { showFeedback } = store.getState().property;
      const urlParams = new URLSearchParams(window.location.search);
      const isJAI = urlParams.get("isjai");
      const isChecked = state.params?.checked;
      const appSSID = state.window.appSSID || null;
      const sequence = JSON.parse(localStorage.getItem(`events_${appSSID}`));

      const metadata = {
        sequence: sequence,
      };
      const jsonString = JSON.stringify(metadata);

      return new Promise((resolve, reject) => {
        const payload = {
          property_id: propertyId,
          api_key: apiKey,
          sessionId: appSSID,
          smsOptIn: isChecked,
          metaData: `${jsonString.replace(/"/g, '\\"')}`,
          originator: "chat",
        };

        const payload4Contact = {
          ...checkCustomQues,
          property_id: propertyId,
          api_key: apiKey,
          status: "Active",
          sub_status: "Scheduled",
          sessionId: appSSID,
          flow: "schedule_tour",
          property_website: !isJAI,
          smsOptIn: isChecked,
        };

        const botMessages = [];

        if (!_.isEmpty(bedroomType)) {
          payload.desiredBedrooms = bedroomType;
        }

        if (!_.isEmpty(desiredMoveIn)) {
          payload.desiredMoveIn = desiredMoveIn;
        }

        if (priceRange.length > 0 && priceRange[0] !== "") {
          payload.desiredPriceLow = priceRange[0];
          payload.desiredPriceHigh = priceRange[1] ? priceRange[1] : priceRange[0];
        }

        if (!_.isEmpty(userEmail)) {
          payload.email = userEmail;
          payload4Contact.email = userEmail;
        }

        if (!_.isEmpty(phoneNumber)) {
          payload.telephone = phoneNumber;
          payload4Contact.phone_number = phoneNumber;

          if (store.getState().property.showContactSMSOpt) {
            payload4Contact.smsOptIn = isChecked;
          }
        }

        if (!_.isEmpty(firstName)) {
          payload.firstName = firstName;
          payload4Contact.first_name = firstName;
        }

        if (!_.isEmpty(lastName)) {
          payload.lastName = lastName;
          payload4Contact.last_name = lastName;
        }

        if (!_.isEmpty(selectedTourTime)) {
          const date = moment(selectedTourTime, "YYYY-MM-DD hh:mm:ss A");

          const formattedDate = date.format("YYYY-MM-DD");
          const formattedTime = date.format("hh:mm:ss A");

          payload.date = formattedDate;
          payload.time = formattedTime;
        }

        if (!_.isEmpty(selectedTourType)) {
          payload.appointmentType = selectedTourType;
        }

        const currentTourAction = localStorageContext?.[0]?.tourAction;
        const currentBooking = localStorageContext?.[0]?.booking_found;
        const currentRequiredInfo = localStorageContext?.[0]?.required_info;

        const isRescheduleInquiry =
          currentBooking && !currentRequiredInfo && (currentTourAction === "reschedule_inquiry" || currentTourAction === "status_inquiry");
        // const isScheduleInquiry = currentTourAction === "schedule_inquiry";
        const isScheduleInquiry = SCHEDULE_TOUR_INQUIRIES.includes(currentTourAction);

        if (isScheduleInquiry || isRescheduleInquiry) {
          store.dispatch(setIsDisabled(true));

          const history = getLastConversations(allMessages, 5)
            ?.map((i) => ({
              role: i.speaker === "bot" || i.speaker === "faqBot" ? "assistant" : "user",
              content: i.message,
            }))
            .filter((i) => i.content && i.content.trim() !== "");

          const faqReply = {
            history,
            propertyId,
            orgId,
            message: isRescheduleInquiry ? "rescheduleTour" : "Schedule a Tour",
            conversation_id: conversationID,
            session_id: appSSID || DEFAULT_SESSION_ID,
            graphql_api_key: encodedApiKey,
            tourScheduleEnabled: enabledScheduleTour,
            entry_id: String(entryId ?? ""),
            spanish_support_enabled: !!isMultiLanguageEnabled,
            spanish_toggle: !!isSpanishCurrentLanguage,
          };

          if (isRescheduleInquiry) {
            faqReply["reschedule_information"] = {
              email: payload?.email,
              phoneNumber: payload?.telephone,
              newPreferredDate: payload?.date,
              newPreferredTime: payload?.time,
              bookingId: bookingId,
            };
          } else if (isScheduleInquiry) {
            faqReply["schedule_information"] = { ...payload };
          }

          return getFAQsReply(faqReply)
            .then((faqResponse) => {
              const availableSlots = faqResponse?.data?.response?.available_slots;

              if (availableSlots && typeof availableSlots === "object") {
                const entryID = availableSlots?.booking?.entry_id;
                const email = availableSlots?.booking?.contact?.email;

                if (entryID && entryId !== entryID) {
                  updateConversationEntryId(entryID, email);
                }
              }

              resolve({ data: faqResponse?.data });
            })
            .catch((err) => {
              console.error("FAQ Reply Error:", err);
              store.dispatch(setIsDisabled(false));
              reject(err);
            });
        }

        scheduleTour(payload)
          .then(async (res) => {
            // NEW CASE: Handle when API returns only available slots array (expired slot scenario)
            if (Array.isArray(res.data) && res.data.length > 0 && !res.data.booking) {
              // Extract the selected slot information that expired
              const selectedSlotTime = payload.time;
              const selectedSlotDate = payload.date;
              const selectedTourType = payload.appointmentType;

              // Parse the available slots from the response
              const availableSlots = res.data;
              let nextAvailableSlot = null;
              let nextAvailableSlotFormatted = "";
              let actualTourType = selectedTourType;

              // Find which tour type key actually exists in the response
              // The API may return only the specific tour type requested
              const tourTypeKey =
                selectedTourType === "in_person_tour" ? "in_person_tour" : selectedTourType === "live_video_tour" ? "live_video_tour" : "self_guided_tour";

              let slotsForType = availableSlots[0]?.[tourTypeKey];

              // If the selected tour type is not in the response, find any available tour type
              if (!slotsForType) {
                // Check for any available tour type in the response
                const availableTourTypes = ["in_person_tour", "live_video_tour", "self_guided_tour"];
                for (const type of availableTourTypes) {
                  if (availableSlots[0]?.[type]?.length > 0) {
                    slotsForType = availableSlots[0][type];
                    actualTourType = type;
                    break;
                  }
                }
              }

              if (slotsForType && slotsForType.length > 0) {
                nextAvailableSlot = slotsForType[0].time_slot;

                // Format the next available slot for display
                const slotMoment = moment(nextAvailableSlot, "YYYY-MM-DD hh:mm:ss A");
                const formattedDate = slotMoment.format("ddd, MMM Do");
                const formattedTime = slotMoment.format("h:mm A");
                nextAvailableSlotFormatted = `${formattedDate} at ${formattedTime}`;

                // Update the slots in Redux so form shows fresh available slots
                handleTourResponse(availableSlots, true, actualTourType);
              }

              // Format the expired slot for display
              const expiredSlotMoment = moment(`${selectedSlotDate} ${selectedSlotTime}`, "YYYY-MM-DD hh:mm:ss A");
              const expiredSlotFormatted = expiredSlotMoment.format("h:mm A");

              // Create a detailed message for the user
              const botMessages = [];

              if (nextAvailableSlotFormatted) {
                botMessages.push(
                  `The selected slot (${expiredSlotFormatted}) is no longer available. Please select another appointment. The next available slot is <span class="hayley-font-semibold">${nextAvailableSlotFormatted}</span>.`
                );
              } else {
                botMessages.push("sorrySelectSlotNoAvail");
              }

              // Keep the schedule tour form open with updated slots (instead of showing feedback options)
              const updatedScheduleTourOptions = updatePhoneNumberOptional(FORM_4_SCHEDULE_TOUR_REPLIES.options, isPhoneNumberRequired);

              const updatedScheduleTourReplies = {
                ...FORM_4_SCHEDULE_TOUR_REPLIES,
                options: updatedScheduleTourOptions,
              };

              resolve({
                data: updatedScheduleTourReplies,
                extraData: { botMessages },
              });
            } else if (res.data.bookingFailureCause === "SLOT_UNAVAILABLE") {
              // Clear tour data so user can select a fresh available slot
              store.dispatch(resetScheduleTourState());
              store.dispatch(setShouldFetchSlots(true));

              resolve({
                data: {
                  ...FEEDBACK_TOUR_REPLIES,
                  title: "oopsSelectSlotNoAvail",
                },
                extraData: { botMessages: ["sorrySelectSlotNoAvail"] },
              });
            } else if (!res.data.bookingFailureCause || res.data.bookingFailureCause === "NONE") {
              localStorage.setItem(`${propertyId}-bookingId`, res.data.booking?.id);

              payload4Contact.entry_id = res.data.booking.contact.id;

              if (res.data.booking.contact.id) {
                await createItemRecord(propertyId, appSSID, "scheduled tour", res.data.booking.contact.id);
                updateConversationEntryId(res.data.booking.contact.id, res.data.booking.contact.email);
              }

              await createNewContact(payload4Contact);

              try {
                const encodedApiKey = encodeURIComponent(apiKey);
                const tourTypeForSlots = selectedTourType || appointmentType;
                const slotsURL = `?property_id=${propertyId}&api_key=${encodedApiKey}&tour_type=${tourTypeForSlots}`;
                const { data: updatedSlots } = await getAvailableDates(slotsURL);

                if (updatedSlots?.length) {
                  handleTourResponse(updatedSlots, true, tourTypeForSlots);
                }
              } catch (slotsError) {
                console.error("Error fetching updated slots after tour scheduling:", slotsError);
              }

              const fullName = `<span class="hayley-font-semibold">${res.data.booking.contact.first_name || ""} ${
                res.data.booking.contact.last_name || ""
              }</span>`;
              const date = `<span class="hayley-font-semibold">${moment(res.data.booking.slot.datetime, "YYYY-MM-DD hh:mm A").format("ddd, MMM Do")}</span>`;
              const time = `<span class="hayley-font-semibold">${moment(res.data.booking.slot.datetime, "YYYY-MM-DD hh:mm A").format("hh:mm a")}</span>`;
              const email = `<span class="hayley-font-semibold">${res.data.booking.contact.email}</span>`;

              if (res.data.already_scheduled) {
                const tourType = res.data.booking.appointmentType;
                botMessages.push(t("alreadyBookedMessage", { tourType, date, time, email }));
                botMessages.push(t("howHelp"));
              } else {
                if (appointmentType === "in_person_tour") {
                  botMessages.push(t("bookedInPersonMessage", { fullName, date, time, email }));
                } else if (appointmentType === "live_video_tour" && res.data.live_tour_link) {
                  botMessages.push(t("bookedLiveVideoMessage", { fullName, date, time, email }));
                } else if (appointmentType === "self_guide_tour" || appointmentType === "self_guided_tour") {
                  botMessages.push(t("bookedSelfGuideMessage", { fullName, date, time, email }));
                }

                if (showFeedback) {
                  botMessages.push(t("howExp"));
                }
              }

              const data = filterFaqOptions(POST_SCHEDULE_TOUR_REPLIES);

              // Clear tour data after successful submission so next time form is opened, it fetches fresh data
              store.dispatch(resetScheduleTourState());
              store.dispatch(setShouldFetchSlots(true));

              resolve({
                data: res.data.already_scheduled ? INITIAL_REPLIES : showFeedback ? FEEDBACK_TOUR_REPLIES : data,
                extraData: { botMessages },
                entryId: res.data.booking.contact.id,
              });
            }
          })
          .catch((err) => reject(err));
      });
    }
    case "PostScheduleTourFromFaq": {
      const history = getLastConversations(allMessages, 5)
        ?.map((i) => ({
          role: i.speaker == "bot" || i.speaker == "faqBot" ? "assistant" : "user",
          content: i.message,
        }))
        .filter((i) => i.content && i.content.trim() !== "");
      // const booking = { booking: { id: bookingId } };

      //making payload for tour details
      const isChecked = state.params?.checked;
      const appSSID = state.window.appSSID || null;
      const tourAction = state.scheduleTour.tourAction || "";
      const sequence = JSON.parse(localStorage.getItem(`events_${appSSID}`));

      const metadata = {
        sequence: sequence,
      };
      const jsonString = JSON.stringify(metadata);

      const payload = {
        property_id: propertyId,
        api_key: apiKey,
        sessionId: appSSID,
        smsOptIn: isChecked,
        metaData: `${jsonString.replace(/"/g, '\\"')}`,
        originator: "chat",
      };

      if (!_.isEmpty(bedroomType)) {
        payload.desiredBedrooms = bedroomType;
      }

      if (!_.isEmpty(desiredMoveIn)) {
        payload.desiredMoveIn = desiredMoveIn;
      }

      if (priceRange.length > 0 && priceRange[0] !== "") {
        payload.desiredPriceLow = priceRange[0];
        payload.desiredPriceHigh = priceRange[1] ? priceRange[1] : priceRange[0];
      }

      if (!_.isEmpty(userEmail)) {
        payload.email = userEmail;
      }

      if (!_.isEmpty(phoneNumber)) {
        payload.telephone = phoneNumber;
      }

      if (!_.isEmpty(firstName)) {
        payload.firstName = firstName;
      }

      if (!_.isEmpty(lastName)) {
        payload.lastName = lastName;
      }

      if (!_.isEmpty(selectedTourTime)) {
        const date = moment(selectedTourTime, "YYYY-MM-DD hh:mm:ss A");

        const formattedDate = date.format("YYYY-MM-DD");
        const formattedTime = date.format("hh:mm:ss A");

        payload.date = formattedDate;
        payload.time = formattedTime;
      }

      if (!_.isEmpty(selectedTourType)) {
        payload.appointmentType = selectedTourType;
      }

      const faqReply = {
        history,
        propertyId,
        orgId: orgId,
        message: tourAction + " " + JSON.stringify(payload) || "",
        conversation_id: conversationID,
        session_id: appSSID || DEFAULT_SESSION_ID,
        graphql_api_key: encodedApiKey,
        tourScheduleEnabled: enabledScheduleTour,
        spanish_support_enabled: !!isMultiLanguageEnabled,
        spanish_toggle: !!isSpanishCurrentLanguage,
      };

      return getFAQsReply(faqReply);
    }

    case "SelfTour":
      return new Promise((resolve, reject) => {
        const { self_tour_link } = store.getState().property;

        resolve({ data: SELF_TOUR_REPLIES, extraData: self_tour_link });
      });
    case "Form4ContactUs":
      return new Promise((resolve, reject) => {
        const updatedContactUsOptions = updatePhoneNumberOptional(FORM_4_CONTACT_US_REPLIES.options, isPhoneNumberRequired);

        const updatedContactUsReplies = {
          ...FORM_4_CONTACT_US_REPLIES,
          options: updatedContactUsOptions,
        };
        resolve({ data: updatedContactUsReplies });
      });
    case "PostContactUs": {
      const { showFeedback } = store.getState().property;
      const isChecked = state.params?.checked;
      let parsedAgentHandoff = {};
      const storedAgentHandoff = localStorage.getItem(`${propertyId}-agentHandOff`);
      parsedAgentHandoff = storedAgentHandoff ? JSON.parse(storedAgentHandoff) : {};

      return new Promise((resolve, reject) => {
        const payload = {
          ...checkCustomQues,
          property_id: propertyId,
          api_key: apiKey,
          status: "Active",
          sub_status: "New",
          sessionId: appSSID,
          flow: "contact_us",
          smsOptIn: isChecked,
          property_website: !isJAI,
        };

        const email = `<span class="hayley-font-semibold">${userEmail}</span>`;

        let queryParam = `?api_key=${encodedApiKey}&property_id=${propertyId}`;
        const botMessage = t("contactSubmitMsg", { email });

        const feedBackMsg = showFeedback ? [botMessage, t("howExp")] : [botMessage];

        if (!_.isEmpty(userEmail)) {
          payload.email = userEmail;
          queryParam += `&email=${encodeURIComponent(userEmail)}`;
        }

        if (!_.isEmpty(phoneNumber)) {
          payload.phone_number = phoneNumber;

          if (store.getState().property.showContactSMSOpt) {
            payload.smsOptIn = isChecked;
          }

          queryParam += `&telephone=${phoneNumber}`;
        }

        if (!_.isEmpty(firstName)) {
          payload.first_name = firstName;
        }

        if (!_.isEmpty(lastName)) {
          payload.last_name = lastName;
        }

        const data = filterFaqOptions(POST_CONTACT_US_REPLIES);

        const obj = {
          data: showFeedback ? FEEDBACK_CONTACT_REPLIES : data,
          extraData: { botMessages: feedBackMsg },
        };

        findUserEntry(queryParam)
          .then((res) => {
            payload.entry_id = res.data.id;

            // const updatedApiKey = store.getState().property.api_key || "";
            // payload.api_key = updatedApiKey;

            createNewContact(payload)
              .then((res) => {
                createItemRecord(propertyId, appSSID, "guest card", res?.data?.id);

                if (res?.data?.id) {
                  updateConversationEntryId(res.data.id, payload.email);

                  if (
                    localStorageContext?.[0]?.need_info === "entryId" ||
                    (parsedAgentHandoff?.need_info === "entry_id" && parsedAgentHandoff?.agent_handoff_triggered)
                  ) {
                    store.dispatch(setIsDisabled(true));

                    const history = getLastConversations(allMessages, 5)
                      ?.map((i) => ({
                        role: i.speaker === "bot" || i.speaker === "faqBot" ? "assistant" : "user",
                        content: i.message,
                      }))
                      .filter((i) => i.content && i.content.trim() !== "");

                    // const booking = { booking: { id: bookingId } };

                    const faqReply = {
                      history,
                      propertyId,
                      orgId,
                      message: usersFaqMsg || "",
                      conversation_id: conversationID,
                      session_id: appSSID || DEFAULT_SESSION_ID,
                      graphql_api_key: encodedApiKey,
                      tourScheduleEnabled: enabledScheduleTour,
                      entry_id: String(res.data?.id ?? ""),
                      spanish_support_enabled: !!isMultiLanguageEnabled,
                      spanish_toggle: !!isSpanishCurrentLanguage,
                    };

                    return getFAQsReply(faqReply)
                      .then((faqResponse) => {
                        resolve({ data: faqResponse?.data });
                      })
                      .catch((err) => {
                        console.error("FAQ Reply Error:", err);
                        store.dispatch(setIsDisabled(false));
                        reject(err);
                      });
                  }
                }

                // fallback for normal case
                resolve(obj);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => {
            if (err.response?.data.error === "Contact Not Found") {
              // const updatedApiKey = store.getState().property.api_key || "";
              // payload.api_key = updatedApiKey;

              createNewContact(payload)
                .then((res) => {
                  createItemRecord(propertyId, appSSID, "guest card", res?.data?.id);

                  if (res?.data?.id) {
                    updateConversationEntryId(res.data.id, payload.email);

                    if (
                      localStorageContext?.[0]?.need_info === "entryId" ||
                      (parsedAgentHandoff?.need_info === "entry_id" && parsedAgentHandoff?.agent_handoff_triggered)
                    ) {
                      store.dispatch(setIsDisabled(true));

                      const history = getLastConversations(allMessages, 5)
                        ?.map((i) => ({
                          role: i.speaker === "bot" || i.speaker === "faqBot" ? "assistant" : "user",
                          content: i.message,
                        }))
                        .filter((i) => i.content && i.content.trim() !== "");

                      // const booking = { booking: { id: bookingId } };

                      const faqReply = {
                        history,
                        propertyId,
                        orgId,
                        message: usersFaqMsg || "",
                        conversation_id: conversationID,
                        session_id: appSSID || DEFAULT_SESSION_ID,
                        graphql_api_key: encodedApiKey,
                        tourScheduleEnabled: enabledScheduleTour,
                        entry_id: String(res.data?.id ?? ""),
                        spanish_support_enabled: !!isMultiLanguageEnabled,
                        spanish_toggle: !!isSpanishCurrentLanguage,
                      };

                      return getFAQsReply(faqReply)
                        .then((faqResponse) => {
                          resolve({ data: faqResponse?.data });
                        })
                        .catch((err) => {
                          console.error("FAQ Reply Error:", err);
                          store.dispatch(setIsDisabled(false));
                          reject(err);
                        });
                    }
                  }

                  resolve(obj);
                })
                .catch((err) => reject(err));
            } else {
              reject(err);
            }
          });
      });
    }
    case "VisitResidentPortal":
      return new Promise((resolve, reject) => {
        getResidentPortalLink(`?api_key=${encodedApiKey}&property_id=${propertyId}`)
          .then((res) => {
            resolve({
              data: VISIT_RESIDENT_PORTAL_REPLIES,
              extraData: res.data,
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    case "Photos":
      if (photos) {
        return Promise.resolve({ data: photos });
      }

      return new Promise((resolve, reject) => {
        getGallery(`?api_key=${encodedApiKey}&property_id=${propertyId}`)
          .then((res) => {
            if (!res.data) {
              const requestOption = {
                tag: "NO_DATA_SHOWN",
                metric: "Surprise",
                propertyId: propertyId,
                sessionId: appSSID,
                appSubsection: "photos",
              };
              createEventSignal(requestOption);
            }

            resolve({ data: res.data });
          })
          .catch((err) => {
            reject(err);
          });
      });

    case "Gallery":
      return new Promise((resolve, reject) => {
        if (data) {
          resolve({ data: data });
        } else if (store.getState().gallery.selectedId) {
          resolve({ data: data });
        } else {
          reject("No item selected");
        }
      });
    case "CommunityInfo":
      return new Promise((resolve, reject) => {
        getPolicies(`?api_key=${encodedApiKey}&property_id=${propertyId}`)
          .then((res) => {
            if (!res.data) {
              const requestOption = {
                tag: "NO_DATA_SHOWN",
                metric: "Surprise",
                propertyId: propertyId,
                sessionId: appSSID,
                appSubsection: "Community info",
              };
              createEventSignal(requestOption);
            }

            resolve({ data: res.data });
          })
          .catch((err) => {
            reject(err);
          });
      });
    case "FeaturesView":
      return new Promise((resolve, reject) => {
        if (data) {
          store.dispatch(setSelectedBadgeItemId(data.toLowerCase()));
          resolve({ data: null });
        } else if (store.getState().badgeSwitch.selectedId) {
          resolve({ data: null });
        } else {
          reject("No item selected");
        }
      });
    case "Videos":
      return new Promise((resolve, reject) => {
        getVideos(`?api_key=${encodedApiKey}&property_id=${propertyId}`)
          .then((res) => {
            if (!res.data) {
              const requestOption = {
                tag: "NO_DATA_SHOWN",
                metric: "Surprise",
                propertyId: propertyId,
                sessionId: appSSID,
                appSubsection: "videos",
              };
              createEventSignal(requestOption);
            }

            resolve({ data: res.data });
          })
          .catch((err) => {
            reject(err);
          });
      });
    case "VideosGallery":
      return new Promise((resolve, reject) => {
        if (data) {
          store.dispatch(setSelectedVideoSwitchId(data.toLowerCase()));
          resolve({ data: null });
        } else if (store.getState().videos.selectedId) {
          resolve({ data: null });
        } else {
          reject("No item selected");
        }
      });
    case "FAQs":
      return new Promise((resolve, reject) => {
        resolve({ data: FAQS_REPLIES });
      });
    case "DoIQualify":
      return new Promise((resolve, reject) => {
        resolve({ data: DO_I_QUALIFY_REPLIES });
      });
    case "customButton":
      return new Promise((resolve) => {
        resolve({ data: customButtonData.find((cb) => cb.id === customButtonId) });
      });
    case "Init": {
      const dup = structuredClone(INITIAL_REPLIES);

      if (!state.property.enabled_schedule_a_tour) {
        dup.options = dup.options.filter((o) => o.nextOptionsType !== "Form4ScheduleTour");
      }

      // if (!state.property.qualificationButtonEnabled) {
      //   dup.options = dup.options.filter((o) => o.nextOptionsType !== "DoIQualify");
      // }

      const custom_buttons = state.property.customButtons;

      if (!_.isEmpty(custom_buttons) && !_.isEmpty(custom_buttons[0])) {
        custom_buttons.forEach((custom_button) => {
          if (!custom_button.state) {
            return;
          }

          let button = structuredClone(CUSTOM_BUTTON);
          button.content.componentOptions.label = custom_button?.button_label;
          button.content.component = custom_button?.action === "url" ? button.content.component : "NormalOptionTile";
          button.nextOptionsType = custom_button?.action === "markdown" ? "customButton" : null;
          button.content.componentOptions.icon = custom_button?.action === "url" ? button.content.componentOptions.icon : null;
          button.content.componentOptions.id = custom_button?.id;

          if (custom_button.action === "url") {
            button.content.componentOptions.link = custom_button?.url;
          } else {
            button.content.componentOptions.text = custom_button?.text;
          }

          dup.options.push(button);
        });
      }

      return new Promise((resolve) => {
        resolve({ data: dup });
      });
    }
    case "Cancel": {
      return new Promise((resolve) => {
        resolve({ data: { ...INITIAL_REPLIES, options: [] } });
      });
    }
    default:
      return new Promise((resolve, reject) => {
        resolve({ data: INITIAL_REPLIES });
      });
  }
};

export const makeNextOptions = (optionType, data, extraData, isAMA, skip, context, not_available, resMessage) => {
  const state = store.getState();
  const qualification = store.getState().property.qualificationButton;
  const isPriceFilter = store.getState().property.isPriceFilter;
  const propertyId = store?.getState()?.property?.property_id || "";
  const appSSID = state.window.appSSID || "";
  //payload for case 3 reply
  const bedType = state.params.label.bedroom_type || "";
  const desiredMoveIn = state.params.label.desired_move_in || "";
  const price = state.params.label.price || "";

  switch (optionType) {
    case "BedroomTypes": {
      if (skip === "bedroomType") {
        store.dispatch(setBudgets(data));

        const options =
          data?._form_desired_price_range?.map((item, idx) => ({
            content: {
              component: "NormalOptionTile",
              componentOptions: {
                icon: null,
                label: item.Display,
                callbackOptions: {
                  data: { data: item.value, name: "price" },
                  triggerType: "SAVE_2_LOCAL_STORAGE",
                },
              },
            },
            nextOptionsType: desiredMoveIn ? "PriceBrackets" : "WhenMoveIn",
            message: [{ message: item.Display, speaker: "user" }],
            key: "price range",
            event: "h_click",
            disablePlaceholerMessage: false,
            data: null,
          })) || [];

        const customPriceOption = [
          {
            content: {
              component: "RangeSlider",
              componentOptions: {
                icon: null,
                label: "customRange",
                callbackOptions: {
                  data: { data: data._custom_price_range, name: "price" },
                  triggerType: "SAVE_2_LOCAL_STORAGE",
                },
              },
            },
            nextOptionsType: desiredMoveIn ? "PriceBrackets" : "WhenMoveIn",
            message: [],
            key: "price range",
            event: "h_click",
            disablePlaceholerMessage: false,
            data: null,
          },
          {
            content: {
              component: "NormalOptionTile",
              componentOptions: {
                icon: null,
                label: "any",
                callbackOptions: {
                  data: { data: null, name: "price" },
                  triggerType: "SAVE_2_LOCAL_STORAGE",
                },
              },
            },
            nextOptionsType: desiredMoveIn ? "Units" : "WhenMoveIn",
            message: [{ message: "any", speaker: "user" }],
            key: "price range",
            event: "h_click",
            disablePlaceholerMessage: false,
            data: null,
          },
        ];

        let message = "shareMonthlyBudget";

        if (not_available?.length > 1) {
          const requestOption = {
            tag: "NO_FLOOR_PLAN_SHOWED",
            metric: "Surprise",
            propertyId: propertyId,
            sessionId: appSSID,
            appSubsection: "No floor plan showed",
          };
          createEventSignal(requestOption);
          message = textConstants.multiOptNotAvail;
        } else if (not_available?.includes("bedroom_type")) {
          message = textConstants.bedroomNotAvail;
        } else if (not_available?.includes("price_range")) {
          message = textConstants.budgetNotAvail;
        } else if (not_available?.includes("desired_move_in")) {
          message = textConstants.moveInNotAvail;
        }

        const nextMsgs = [];

        if (resMessage && isAMA) {
          nextMsgs.push({ message: resMessage, speaker: "bot" });
        }

        nextMsgs.push({ message: message, speaker: "bot" });

        return {
          nextReplies: {
            options: [...options, ...customPriceOption],
            renderType: "boxView",
            optionsType: "PriceBrackets",
            checkStorage: false,
            disableResetBox: false,
            title: "",
          },
          nextBotMessages: nextMsgs,
        };
      }

      if (skip === "getPriceRange") {
        const options = data.options.map((o) => {
          let data2Save = "";

          switch (o.content?.componentOptions?.label) {
            case "asap":
              data2Save = moment().add(7, "days").format("YYYY-MM-DD");
              break;
            case "next30Days":
              data2Save = moment().add(30, "days").format("YYYY-MM-DD");
              break;
            case "next60Days":
              data2Save = moment().add(60, "days").format("YYYY-MM-DD");
              break;
            case "notSure":
              data2Save = null;
              break;
            default:
              break;
          }

          const content = {
            ...o.content,
            componentOptions: {
              ...o.content.componentOptions,
              callbackOptions: {
                data: { data: data2Save, name: "desired_move_in" },
                triggerType: "SAVE_2_LOCAL_STORAGE",
              },
            },
          };

          return { ...o, content };
        });

        store.dispatch(setFilterDates(false));

        return {
          nextReplies: { ...data, options },
          nextBotMessages: [
            { message: resMessage, speaker: "bot" },
            { message: "planMove", speaker: "bot" },
          ],
        };
      }

      if (skip === "DesiredMoveInDate" || skip === "floorPlans") {
        const message = t("unitMatchPref", { count: data.length });
        let messages = [{ message: message, speaker: "bot" }];

        if (data?.length > 0) {
          const options = data.map((item) => ({
            content: { component: "UnitItem", componentOptions: null },
            message: [],
            nextOptionsType: null,
            key: item.id,
            event: "h_click",
            disablePlaceholerMessage: false,
            data: item,
          }));

          return {
            nextReplies: {
              options,
              title: null,
              renderType: "unitView",
              optionsType: "Init",
              checkStorage: false,
              disableResetBox: false,
            },
            nextBotMessages: messages,
          };
        }

        if (optionType === "UnitsAll") {
          const requestOption = {
            tag: "NO_FLOOR_PLAN_SHOWED",
            metric: "Surprise",
            propertyId: propertyId,
            sessionId: appSSID,
            appSubsection: "No floor plan showed",
          };
          createEventSignal(requestOption);

          return {
            nextReplies: {
              options: _.filter(INITIAL_REPLY_OPTIONS, (o) => !["find_home"].includes(o.key)),
              title: "",
              renderType: "boxView",
              optionsType: "Init",
              checkStorage: false,
              disableResetBox: false,
            },
            nextBotMessages: [
              {
                message: skip === "floorPlans" ? resMessage || "noAvailFloorPlanWhatNext" : "noAvailUnitWhatNext",
                speaker: "bot",
              },
            ],
          };
        }
      }

      if (skip === "noConditionMatched") {
        return {
          nextReplies: INITIAL_REPLIES,
          nextBotMessages: [
            {
              message: resMessage || "Cannot find any matching units.",
              speaker: "bot",
            },
          ],
        };
      }

      store.dispatch(setBedRooms(data));

      const options = data?.map((item, idx) => ({
        content: {
          component: "NormalOptionTile",
          componentOptions: {
            icon: "",
            label: item.value,
            callbackOptions: {
              data: { data: item.value, name: "bedroom_type" },
              triggerType: "SAVE_2_LOCAL_STORAGE",
            },
          },
        },
        nextOptionsType: isPriceFilter ? "PriceBrackets" : "WhenMoveIn",
        message: [{ message: item.value, speaker: "user" }],
        key: "bedrooms",
        event: "h_click",
        disablePlaceholerMessage: false,
        data: null,
      }));
      let message = "howManyBedroom";

      if (not_available?.length > 1) {
        message = textConstants.multiOptNotAvail;
      } else if (not_available?.includes("bedroom_type")) {
        message = textConstants.bedroomNotAvail;
      } else if (not_available?.includes("price_range")) {
        message = textConstants.budgetNotAvail;
      } else if (not_available?.includes("desired_move_in")) {
        message = textConstants.moveInNotAvail;
      }

      let botMessages = [{ message: message, speaker: "bot" }];

      if (resMessage) {
        botMessages.unshift({ message: resMessage, speaker: "bot" });
      }

      return {
        nextReplies: {
          options: !isAMA ? [...options, SHOW_ALL_UNITS_OPTION] : [...options, SHOW_ALL_UNITS_OPTION, CANCEL_OPTION],
          renderType: "boxView",
          optionsType: "BedroomTypes",
          title: "",
          disableResetBox: false,
          checkStorage: false,
        },

        nextBotMessages: botMessages,
      };
    }
    case "PriceBrackets": {
      if (skip === "getPriceRange") {
        const options = data.options.map((o) => {
          let data2Save = "";

          switch (o.content?.componentOptions?.label) {
            case "asap":
              data2Save = moment().add(7, "days").format("YYYY-MM-DD");
              break;
            case "next30Days":
              data2Save = moment().add(30, "days").format("YYYY-MM-DD");
              break;
            case "next60Days":
              data2Save = moment().add(60, "days").format("YYYY-MM-DD");
              break;
            case "notSure":
              data2Save = null;
              break;
            default:
              break;
          }

          const content = {
            ...o.content,
            componentOptions: {
              ...o.content.componentOptions,
              callbackOptions: {
                data: { data: data2Save, name: "desired_move_in" },
                triggerType: "SAVE_2_LOCAL_STORAGE",
              },
            },
          };

          return { ...o, content };
        });

        store.dispatch(setFilterDates(false));

        let msgs = [{ message: "planMove", speaker: "bot" }];

        if (resMessage) {
          msgs.unshift({ message: resMessage, speaker: "bot" });
        }

        return {
          nextReplies: { ...data, options },
          nextBotMessages: msgs,
        };
      }

      if (skip === "DesiredMoveInDate") {
        if (data.length > 0) {
          const options = data.map((item) => ({
            content: { component: "UnitItem", componentOptions: null },
            message: [],
            nextOptionsType: null,
            key: item.id,
            event: "h_click",
            disablePlaceholerMessage: false,
            data: item,
          }));

          const message = skip === "floorPlans" ? t("floorPlanMatchPref", { count: data.length }) : t("unitMatchPref", { count: data.length });

          return {
            nextReplies: {
              options,
              title: null,
              renderType: "unitView",
              optionsType: "Init",
              checkStorage: false,
              disableResetBox: false,
            },
            nextBotMessages: [{ message: message, speaker: "bot" }],
          };
        }

        if (optionType === "UnitsAll") {
          const requestOption = {
            tag: "NO_FLOOR_PLAN_SHOWED",
            metric: "Surprise",
            propertyId: propertyId,
            sessionId: appSSID,
            appSubsection: "No floor plan showed",
          };
          createEventSignal(requestOption);

          return {
            nextReplies: {
              options: _.filter(INITIAL_REPLY_OPTIONS, (o) => !["find_home"].includes(o.key)),
              title: "",
              renderType: "boxView",
              optionsType: "Init",
              checkStorage: false,
              disableResetBox: false,
            },
            nextBotMessages: [
              {
                message: skip === "floorPlans" ? "noAvailFloorPlanWhatNext" : "noAvailUnitWhatNext",
                speaker: "bot",
              },
            ],
          };
        }
      }

      store.dispatch(setBudgets(data));
      const isPriceFilter = store.getState().property.isPriceFilter;

      const options =
        data?._form_desired_price_range?.map((item, idx) => ({
          content: {
            component: "NormalOptionTile",

            componentOptions: {
              icon: null,
              label: item.Display,
              callbackOptions: {
                data: { data: item.value, name: "price" },
                triggerType: "SAVE_2_LOCAL_STORAGE",
              },
            },
          },
          nextOptionsType: desiredMoveIn ? "PriceBrackets" : "WhenMoveIn",
          message: [{ message: item.Display, speaker: "user" }],
          key: "price range",
          event: "h_click",
          disablePlaceholerMessage: false,
          data: null,
        })) || [];

      const customPriceOption = [
        {
          content: {
            component: "RangeSlider",
            componentOptions: {
              icon: null,
              label: "customRange",
              callbackOptions: {
                data: { data: data._custom_price_range, name: "price" },
                triggerType: "SAVE_2_LOCAL_STORAGE",
              },
            },
          },
          nextOptionsType: desiredMoveIn ? "PriceBrackets" : "WhenMoveIn",
          message: [],
          key: "price range",
          event: "h_click",
          disablePlaceholerMessage: false,
          data: null,
        },
        {
          content: {
            component: "NormalOptionTile",
            componentOptions: {
              icon: null,
              label: "any",
              callbackOptions: {
                data: { data: null, name: "price" },
                triggerType: "SAVE_2_LOCAL_STORAGE",
              },
            },
          },
          nextOptionsType: desiredMoveIn ? "Units" : "WhenMoveIn",
          message: [{ message: "any", speaker: "user" }],
          key: "price range",
          event: "h_click",
          disablePlaceholerMessage: false,
          data: null,
        },
      ];

      let message = isPriceFilter ? "shareMonthlyBudget" : "planMove";

      if (not_available?.length > 1) {
        message = textConstants.multiOptNotAvail;
      } else if (not_available?.includes("bedroom_type")) {
        message = textConstants.bedroomNotAvail;
      } else if (not_available?.includes("price_range")) {
        message = textConstants.budgetNotAvail;
      } else if (not_available?.includes("desired_move_in")) {
        message = textConstants.moveInNotAvail;
      }

      return {
        nextReplies: {
          options: [...options, ...customPriceOption],
          renderType: "boxView",
          optionsType: "PriceBrackets",
          checkStorage: false,
          disableResetBox: false,
          title: "",
        },
        nextBotMessages: [{ message: message, speaker: "bot" }],
      };
    }
    case "WhenMoveIn": {
      if (skip === "DesiredMoveInDate") {
        if (data.length > 0) {
          const options = data.map((item) => ({
            content: { component: "UnitItem", componentOptions: null },
            message: [],
            nextOptionsType: null,
            key: item.id,
            event: "h_click",
            disablePlaceholerMessage: false,
            data: item,
          }));

          const message = skip === "floorPlans" ? t("floorPlanMatchPref", { count: data.length }) : t("unitMatchPref", { count: data.length });

          return {
            nextReplies: {
              options,
              title: null,
              renderType: "unitView",
              optionsType: "Init",
              checkStorage: false,
              disableResetBox: false,
            },
            nextBotMessages: [{ message: message, speaker: "bot" }],
          };
        }

        if (optionType === "UnitsAll") {
          const requestOption = {
            tag: "NO_FLOOR_PLAN_SHOWED",
            metric: "Surprise",
            propertyId: propertyId,
            sessionId: appSSID,
            appSubsection: "No floor plan showed",
          };
          createEventSignal(requestOption);

          return {
            nextReplies: {
              options: _.filter(INITIAL_REPLY_OPTIONS, (o) => !["find_home"].includes(o.key)),
              title: "",
              renderType: "boxView",
              optionsType: "Init",
              checkStorage: false,
              disableResetBox: false,
            },
            nextBotMessages: [
              {
                message: skip === "floorPlans" ? "noAvailFloorPlanWhatNext" : "noAvailUnitWhatNext",
                speaker: "bot",
              },
            ],
          };
        }
      }

      const options = data.options.map((o) => {
        let data2Save = "";

        switch (o.content?.componentOptions?.label) {
          case "asap":
            data2Save = moment().add(7, "days").format("YYYY-MM-DD");
            break;
          case "next30Days":
            data2Save = moment().add(30, "days").format("YYYY-MM-DD");
            break;
          case "next60Days":
            data2Save = moment().add(60, "days").format("YYYY-MM-DD");
            break;
          case "notSure":
            data2Save = null;
            break;
          default:
            break;
        }

        const content = {
          ...o.content,
          componentOptions: {
            ...o.content.componentOptions,
            callbackOptions: {
              data: { data: data2Save, name: "desired_move_in" },
              triggerType: "SAVE_2_LOCAL_STORAGE",
            },
          },
        };

        return { ...o, content };
      });

      store.dispatch(setFilterDates(false));

      return {
        nextReplies: { ...data, options },
        nextBotMessages: [{ message: "planMove", speaker: "bot" }],
      };
    }
    case "UnitsAll":
    case "UnitsByRoom":
    case "Units": {
      const units = data?.floor_plans || [];

      store.dispatch(setSearchResult(data?.search_result || false));

      if (units.length > 0) {
        const options = units?.map((item) => ({
          content: { component: "UnitItem", componentOptions: null },
          message: [],
          nextOptionsType: null,
          key: item.id,
          event: "h_click",
          disablePlaceholerMessage: false,
          data: item,
        }));
        let message;

        const apiResponse = {
          buffer_search: data.buffer_search,
          filter_excluded: data.filter_excluded,
        };

        const payload = {
          price_preference: !!price,
          bedroom_preference: !!bedType,
          desired_move_in_date: !!desiredMoveIn,
        };

        let nextMessage;

        if (resMessage && resMessage.trim() !== "") {
          nextMessage = [{ message: resMessage, speaker: "bot" }];

          if (data?.fee_disclaimer) {
            nextMessage.push({
              message: data.fee_disclaimer,
              speaker: "bot",
            });
          }
        } else {
          const allPreferences = Object.values(payload).every(Boolean);

          if (allPreferences && resMessage) {
            message = resMessage;
          } else {
            switch (data?.case?.charAt(0)) {
              case "2":
                message = t(generateDynamicMessage(apiResponse, payload, "floorMatchPref"), {
                  bedroom: bedType,
                  count: units.length,
                });

                break;
              case "3":
                message = t(generateDynamicMessage(apiResponse, payload), {
                  bedroom: bedType,
                  count: units.length,
                });

                break;
              default:
                message = t("floorMatchPref3rd");
            }
          }

          nextMessage =
            optionType === "UnitsAll" && data?.case?.charAt(0) === "2"
              ? [
                  {
                    message: units.length == 1 ? t("genericSingleFloorMatchPref") : t("genericFloorMatchPref", { count: units.length }),
                    speaker: "bot",
                  },
                ]
              : [{ message: message, speaker: "bot" }];

          if (data?.fee_disclaimer) {
            nextMessage.push({
              message: data.fee_disclaimer,
              speaker: "bot",
            });
          }
        }

        return {
          nextReplies: {
            options,
            title: null,
            renderType: "unitView",
            optionsType: "Init",
            checkStorage: false,
            unitCase: data?.case?.charAt(0) || "2",
            disableResetBox: false,
            fees: data?.fees || [],
            feeDisclaimer: data?.fee_disclaimer || null,
            hidePricing: data?.hide_pricing,
            tmlpEnabled: data?.tmlp_enabled,
            allUnitsUrl: data?.all_units_url || null,
            shortTourLink: data?.short_tour_link || null,
          },
          nextBotMessages: nextMessage,
        };
      }

      if (optionType === "UnitsAll") {
        const requestOption = {
          tag: "NO_FLOOR_PLAN_SHOWED",
          metric: "Surprise",
          propertyId: propertyId,
          sessionId: appSSID,
          appSubsection: "No floor plan showed",
        };
        createEventSignal(requestOption);

        return {
          nextReplies: {
            options: _.filter(INITIAL_REPLY_OPTIONS, (o) => !["find_home"].includes(o.key)),
            title: "",
            renderType: "boxView",
            optionsType: "Init",
            checkStorage: false,
            disableResetBox: false,
          },
          nextBotMessages: [
            {
              message: skip === "floorPlans" ? "noAvailFloorPlanWhatNext" : "noAvailUnitWhatNext",
              speaker: "bot",
            },
          ],
        };
      }

      const state = store.getState();
      const bedroomType = state.params.label.bedroom_type || "";

      const options = [SHOW_ALL_UNITS_OPTION, ..._.filter(INITIAL_REPLY_OPTIONS, (o) => ["schedule_tour", "contact_us"].includes(o.key)), EXPLORE_MORE_OPTION];

      const extraOption = {
        content: {
          component: "NormalOptionTile",
          componentOptions: {
            icon: "",
            label: `Show all ${bedroomType.replace("-", " ")}`,
            callbackOptions: null,
          },
        },
        nextOptionsType: "UnitsByRoom",
        message: [
          {
            message: `Show all ${bedroomType.replace("-", " ")}`,
            speaker: "user",
          },
        ],
        key: "extra_units",
        disablePlaceholerMessage: true,
        data: null,
      };

      return {
        nextReplies: {
          options: extraData.enableExtraOption ? [extraOption, ...options] : options,
          title: "",
          renderType: "boxView",
          optionsType: "Init",
          checkStorage: false,
          disableResetBox: false,
        },
        nextBotMessages: [
          {
            message: "noMatchPrefWhatNext",
            speaker: "bot",
          },
        ],
      };
    }

    case "EspNotEnabled": {
      return {
        nextReplies: INITIAL_REPLIES,
        nextBotMessages: [
          {
            message: resMessage || "My apologies, this chat must be conducted in English test",
            speaker: "bot",
          },
          {
            message: "howHelp",
            speaker: "bot",
          },
        ],
      };
    }

    case "end of chat": {
      localStorage.removeItem(`${propertyId}-context`);
      localStorage.removeItem(`${propertyId}-bookingId`);

      return {
        nextReplies: INITIAL_REPLIES,
        nextBotMessages: [
          {
            message: resMessage || t("whatNext"),
            speaker: "bot",
          },
        ],
      };
    }

    case "ScheduleTour": {
      const ctx = context?.[0] ?? {};
      const tourAction = ctx.tourAction ?? null;
      const required_info = ctx.required_info ?? null;
      const need_info = ctx.need_info ?? null;
      const error_code = ctx.error_code ?? null;
      const booking_found = ctx.booking_found ?? null;
      const tourType = ctx.tourType ?? null;

      //adding isFromFaq flag in replies for faq flow
      // data = {
      //   ...data,
      //   isFromFaq: true,
      // };

      let message = state.property.enabled_schedule_a_tour ? resMessage ?? "almostDoneFewMoreDetail" : "noScheduleDetailGet";

      if (!resMessage) {
        if (not_available?.includes("tourType")) {
          message = textConstants.tourNotAvail;
        } else if (not_available?.includes("preferredDate")) {
          message = textConstants.dataNotAvail;
        } else if (not_available?.includes("preferredTime")) {
          message = textConstants.timeNotAvail;
        }
      }

      if (tourAction === "cancel_inquiry") {
        if (required_info && need_info === "entryId") {
          return {
            nextReplies: data ?? INITIAL_REPLIES,
            nextBotMessages: [
              {
                message: "We don't have any booking for you. Please fill the form...",
                speaker: "bot",
              },
            ],
          };
        }

        if (required_info && !booking_found && error_code === 404) {
          return {
            nextReplies: data ?? INITIAL_REPLIES,
            nextBotMessages: [
              {
                message: resMessage?.trim() || "We don't have any booking for you. Please fill the form.",
                speaker: "bot",
              },
            ],
          };
        }

        if (!required_info && booking_found) {
          return {
            nextReplies: CANCEL_TOUR_REPLIES,
            nextBotMessages: [
              {
                message: resMessage?.trim() || t?.("foundConfirmedTourDetails"),
                speaker: "bot",
                subject: "cancel_inquiry",
              },
              {
                message: "wouldLikeToCancel",
                speaker: "bot",
              },
            ],
          };
        }
      }

      if (tourAction === "cancel_confirmation") {
        if (need_info === "bookingId" && required_info) {
          localStorage.removeItem(`${propertyId}-context`);
          // localStorage.removeItem(`${propertyId}-bookingId`);

          return {
            nextReplies: INITIAL_REPLIES,
            nextBotMessages: [
              {
                message:
                  resMessage?.trim() ||
                  "I am having trouble locating your tour information. Could you please share the phone number or email you used when booking? This will help me find and cancel your tour properly.",
                speaker: "bot",
              },
            ],
          };
        }

        if (!booking_found && !required_info) {
          localStorage.removeItem(`${propertyId}-context`);
          // localStorage.removeItem(`${propertyId}-bookingId`);

          return {
            nextReplies: INITIAL_REPLIES,
            nextBotMessages: [
              {
                message:
                  resMessage?.trim() || "I still can't locate your tour. But I've saved your information and will ask a team member to follow up shortly.",
                speaker: "bot",
              },
            ],
          };
        }

        if (booking_found && !required_info) {
          localStorage.removeItem(`${propertyId}-context`);
          localStorage.removeItem(`${propertyId}-bookingId`);

          return {
            nextReplies: INITIAL_REPLIES,
            nextBotMessages: [
              {
                message: resMessage?.trim() || "We have successfully deleted your booking.",
                speaker: "bot",
              },
            ],
          };
        }
      }

      if (tourAction === "reschedule_inquiry") {
        if (need_info === "entryId" && required_info) {
          return {
            nextReplies: data ?? INITIAL_REPLIES,
            nextBotMessages: [
              {
                message: "Got it! To help you better, could you please share your email or phone number?",
                speaker: "bot",
              },
            ],
          };
        }

        if (booking_found && !required_info) {
          data = {
            ...data,
            isReschedule: true,
          };

          return {
            nextReplies: data ?? INITIAL_REPLIES,
            nextBotMessages: [
              {
                message: resMessage?.trim() || t?.("foundConfirmedTourDetails"),
                speaker: "bot",
                subject: "cancel_inquiry",
              },
              {
                message: "rescheduleTourForMe",
                speaker: "bot",
              },
            ],
          };
        }

        if (!booking_found && required_info && error_code === 404) {
          data = {
            ...data,
            isReschedule: true,
          };

          return {
            nextReplies: data ?? INITIAL_REPLIES,
            nextBotMessages: [
              {
                message: resMessage?.trim() || "You don't have a scheduled tour. Please fill the form below:",
                speaker: "bot",
              },
            ],
          };
        }
      }

      if (tourAction === "reschedule_confirmation" || tourAction === "schedule_confirmation") {
        // if (booking_found && !required_info) {
        localStorage.removeItem(`${propertyId}-context`);
        // localStorage.removeItem(`${propertyId}-bookingId`);

        // Clear tour data after successful submission so next time form is opened, it fetches fresh data
        store.dispatch(resetScheduleTourState());
        store.dispatch(setShouldFetchSlots(true));

        return {
          nextReplies: INITIAL_REPLIES,
          nextBotMessages: [
            {
              message:
                resMessage?.trim() ||
                `Your tour has been successfully ${
                  tourAction === "reschedule_confirmation" ? "rescheduled" : "scheduled"
                }. I'll be happy to help you schedule a new one whenever you're ready!`,
              speaker: "bot",
            },
          ],
        };
        // }
      }

      if (tourAction === "status_inquiry") {
        if (required_info && need_info === "entryId" && tourType === "") {
          return {
            nextReplies: data ?? INITIAL_REPLIES,
            nextBotMessages: [
              {
                message:
                  "I don't see a tour scheduled under you current information. Could you please share the phone number or email you used when booking?. This help me locate your tour details.",
                speaker: "bot",
              },
            ],
          };
        }

        if (required_info && !booking_found && error_code === 404) {
          return {
            nextReplies: data ?? INITIAL_REPLIES,
            nextBotMessages: [
              {
                message:
                  resMessage?.trim() ||
                  "I still don't see any tours scheduled with those details. Would you like to book a new tour now? Here are some available times:",
                speaker: "bot",
              },
            ],
          };
        }

        if (booking_found && !required_info) {
          return {
            nextReplies: RESCHEDULE_TOUR_REPLIES ?? INITIAL_REPLIES,
            nextBotMessages: [
              {
                message: resMessage?.trim() || "You have a tour scheduled at Avenue at York!",
                speaker: "bot",
                subject: "cancel_inquiry",
              },
              {
                message: "changeInPlan",
                speaker: "bot",
              },
            ],
          };
        }
      }

      if (tourAction === "tour_type_inquiry") {
        if (booking_found && !required_info) {
          localStorage.removeItem(`${propertyId}-context`);
          // localStorage.removeItem(`${propertyId}-bookingId`);

          return {
            nextReplies: INITIAL_REPLIES,
            nextBotMessages: [
              {
                message: resMessage?.trim() || "We found your tour.",
                speaker: "bot",
              },
            ],
          };
        }
      }

      if (tourAction === "cancel_rejection") {
        return {
          nextReplies: INITIAL_REPLIES,
          nextBotMessages: [
            {
              message: resMessage || t("whatNext"),
              speaker: "bot",
            },
          ],
        };
      }

      return {
        nextReplies: data ?? INITIAL_REPLIES,
        nextBotMessages: [
          {
            message: message || data.response || resMessage || "Something went wrong.",
            speaker: "bot",
          },
        ],
      };
    }

    case "cancelTourFromTourStatus": {
      return {
        nextReplies: CANCEL_TOUR_REPLIES ?? INITIAL_REPLIES,
        nextBotMessages: [
          {
            message: "wouldLikeToCancel",
            speaker: "bot",
          },
        ],
      };
    }

    case "rescheduleFromTourStatus": {
      data = {
        ...data,
        isReschedule: true,
      };

      return {
        nextReplies: data ?? INITIAL_REPLIES,
        nextBotMessages: [
          {
            message: "rescheduleTourForMe",
            speaker: "bot",
          },
        ],
      };
    }

    case "cancelTour": {
      return {
        nextReplies: INITIAL_REPLIES,
        nextBotMessages: [
          {
            message: "Your tour has been successfully canceled.I'll be happy to help you schedule a new one whenever you're ready!",
            speaker: "bot",
          },
        ],
      };
    }

    case "noDoNotCancel": {
      return {
        nextReplies: INITIAL_REPLIES,
        nextBotMessages: [
          {
            message: "We do not delete your booking.",
            speaker: "bot",
          },
        ],
      };
    }

    case "AvailableDates4PersonTour":
    case "AvailableDatesForSelfTour": {
      if (skip === "confirmation") {
        return {
          nextReplies: data,
          nextBotMessages: [{ message: "almostDoneFewMoreDetail", speaker: "bot" }],
        };
      }

      if (skip === "preferredDate") {
        const times = _(data)
          .map((value) => value.replace("  ", " 0"))
          .uniq()
          .value();

        const options = [];

        const amTimeOptions = _(times)
          .filter((value) => moment(value, "YYYY-MM-DD HH:mm:ss A").format("a") === "am")
          .map((value, key) => ({
            content: {
              component: "NormalOptionTile",
              componentOptions: {
                icon: null,
                label: moment(value, "YYYY-MM-DD HH:mm:ss A").format("h:mm a"),
                callbackOptions: {
                  data: { data: value, name: "time" },
                  triggerType: "SAVE_2_LOCAL_STORAGE",
                },
              },
            },
            nextOptionsType: "Form4ScheduleTour",
            message: [
              {
                message: moment(value, "YYYY-MM-DD HH:mm:ss A").format("ddd, MMM D, YYYY - h:mm a"),
                speaker: "user",
              },
            ],
            key: "tour time",
            event: "h_click",
            disablePlaceholerMessage: false,
            data: null,
          }))
          .value();

        const pmTimeOptions = _(times)
          .filter((value) => moment(value, "YYYY-MM-DD HH:mm:ss A").format("a") === "pm")
          .map((value, key) => ({
            content: {
              component: "NormalOptionTile",
              componentOptions: {
                icon: null,
                label: moment(value, "YYYY-MM-DD HH:mm:ss A").format("h:mm a"),
                callbackOptions: {
                  data: { data: value, name: "time" },
                  triggerType: "SAVE_2_LOCAL_STORAGE",
                },
              },
            },
            nextOptionsType: "Form4ScheduleTour",
            message: [
              {
                message: moment(value, "YYYY-MM-DD HH:mm:ss A").format("ddd, MMM D, YYYY - h:mm a"),
                speaker: "user",
              },
            ],
            key: "tour time",
            event: "h_click",
            disablePlaceholerMessage: false,
            data: null,
          }))
          .value();

        if (amTimeOptions.length > 0) {
          options.push({
            content: {
              component: "SubTitleRow",
              componentOptions: { title: "morning" },
            },
            nextOptionsType: null,
            message: [],
            key: "morning_subtitle",
            event: "h_click",
            disablePlaceholerMessage: false,
            data: null,
          });

          options.push(...amTimeOptions);
        }

        if (pmTimeOptions.length > 0) {
          options.push({
            content: {
              component: "SubTitleRow",
              componentOptions: { title: "afternoon" },
            },
            nextOptionsType: null,
            message: [],
            key: "afternoon_subtitle",
            event: "h_click",
            disablePlaceholerMessage: false,
            data: null,
          });

          options.push(...pmTimeOptions);
        }

        return {
          nextReplies: {
            options,
            renderType: "boxView",
            optionsType: "AvailableTimes",
            title: "",
            checkStorage: false,
            disableResetBox: false,
          },
          nextBotMessages: [{ message: "whichTimeWork", speaker: "bot" }],
        };
      }

      const dates = _(data)
        .map((value) => value.date)
        .uniq()
        .value();

      const options = _(dates)
        .map((value, key) => {
          const label = moment(value).isSame(moment(), "day")
            ? "today"
            : moment(value).isSame(moment().add(1, "day"), "day")
            ? "tomorrow"
            : moment(value).format("ddd, MMM D");

          return {
            content: {
              component: "NormalOptionTile",
              componentOptions: {
                icon: null,
                label,
                callbackOptions: {
                  data: { data: value, name: "date" },
                  triggerType: "SAVE_2_LOCAL_STORAGE",
                },
              },
            },
            nextOptionsType: "AvailableTimes",
            message: [
              {
                message: moment(value).format("ddd, MMM D, YYYY"),
                speaker: "user",
              },
            ],
            key: "tour date",
            event: "h_click",
            disablePlaceholerMessage: false,
            data: null,
          };
        })
        .value()
        .slice(0, 3);

      store.dispatch(setFilterDates(true));

      store.dispatch(setAvailableDates(dates.map((date) => moment(date).format("YYYY-MM-DD"))));

      options.push({
        content: {
          component: "DatePickerOptionTile",
          componentOptions: {
            disablePreviousDates: true,
            callbackOptions: {
              data: { name: "date" },
              triggerType: "SAVE_2_LOCAL_STORAGE",
            },
          },
        },
        message: [],
        nextOptionsType: "AvailableTimes",
        key: "date_from_calendar",
        disablePlaceholerMessage: true,
        data: null,
      });

      return {
        nextReplies: {
          options,
          renderType: "boxView",
          optionsType: "AvailableDates4PersonTour",
          title: "",
          checkStorage: false,
          disableResetBox: false,
        },
        nextBotMessages: [{ message: "whenAvailableTour", speaker: "bot" }],
      };
    }
    case "AvailableDates4VideoTour": {
      if (skip === "confirmation") {
        return {
          nextReplies: data,
          nextBotMessages: [{ message: "almostDoneFewMoreDetail", speaker: "bot" }],
        };
      } else if (skip === "preferredDate") {
        const times = _(data)
          .map((value) => value.replace("  ", " 0"))
          .uniq()
          .value();

        const options = [];

        const amTimeOptions = _(times)
          .filter((value) => moment(value, "YYYY-MM-DD HH:mm:ss A").format("a") === "am")
          .map((value, key) => ({
            content: {
              component: "NormalOptionTile",
              componentOptions: {
                icon: null,
                label: moment(value, "YYYY-MM-DD HH:mm:ss A").format("h:mm a"),
                callbackOptions: {
                  data: { data: value, name: "time" },
                  triggerType: "SAVE_2_LOCAL_STORAGE",
                },
              },
            },
            nextOptionsType: "Form4ScheduleTour",
            message: [
              {
                message: moment(value, "YYYY-MM-DD HH:mm:ss A").format("ddd, MMM D, YYYY - h:mm a"),
                speaker: "user",
              },
            ],
            key: "tour time",
            event: "h_click",
            disablePlaceholerMessage: false,
            data: null,
          }))
          .value();

        const pmTimeOptions = _(times)
          .filter((value) => moment(value, "YYYY-MM-DD HH:mm:ss A").format("a") === "pm")
          .map((value, key) => ({
            content: {
              component: "NormalOptionTile",
              componentOptions: {
                icon: null,
                label: moment(value, "YYYY-MM-DD HH:mm:ss A").format("h:mm a"),
                callbackOptions: {
                  data: { data: value, name: "time" },
                  triggerType: "SAVE_2_LOCAL_STORAGE",
                },
              },
            },
            nextOptionsType: "Form4ScheduleTour",
            message: [
              {
                message: moment(value, "YYYY-MM-DD HH:mm:ss A").format("ddd, MMM D, YYYY - h:mm a"),
                speaker: "user",
              },
            ],
            key: "tour time",
            event: "h_click",
            disablePlaceholerMessage: false,
            data: null,
          }))
          .value();

        if (amTimeOptions.length > 0) {
          options.push({
            content: {
              component: "SubTitleRow",
              componentOptions: { title: "morning" },
            },
            nextOptionsType: null,
            message: [],
            key: "morning_subtitle",
            event: "h_click",
            disablePlaceholerMessage: false,
            data: null,
          });

          options.push(...amTimeOptions);
        }

        if (pmTimeOptions.length > 0) {
          options.push({
            content: {
              component: "SubTitleRow",
              componentOptions: { title: "afternoon" },
            },
            nextOptionsType: null,
            message: [],
            key: "afternoon_subtitle",
            event: "h_click",
            disablePlaceholerMessage: false,
            data: null,
          });

          options.push(...pmTimeOptions);
        }

        return {
          nextReplies: {
            options,
            renderType: "boxView",
            optionsType: "AvailableTimes",
            title: "",
            checkStorage: false,
            disableResetBox: false,
          },
          nextBotMessages: [{ message: "whichTimeWork", speaker: "bot" }],
        };
      }

      const dates = _(data)
        .map((value) => value.date)
        .uniq()
        .value();

      const options = _(dates)
        .map((value, key) => {
          const label = moment(value).isSame(moment(), "day")
            ? t("today")
            : moment(value).isSame(moment().add(1, "day"), "day")
            ? t("tomorrow")
            : moment(value).format("ddd, MMM D");

          return {
            content: {
              component: "NormalOptionTile",
              componentOptions: {
                icon: null,
                label,
                callbackOptions: {
                  data: { data: value, name: "date" },
                  triggerType: "SAVE_2_LOCAL_STORAGE",
                },
              },
            },
            nextOptionsType: "AvailableTimes",
            message: [
              {
                message: moment(value).format("ddd, MMM D, YYYY"),
                speaker: "user",
              },
            ],
            key: "tour date",
            event: "h_click",
            disablePlaceholerMessage: false,
            data: null,
          };
        })
        .value()
        .slice(0, 3);

      store.dispatch(setFilterDates(true));

      store.dispatch(setAvailableDates(dates.map((date) => moment(date).format("YYYY-MM-DD"))));

      options.push({
        content: {
          component: "DatePickerOptionTile",
          componentOptions: {
            disablePreviousDates: true,
            callbackOptions: {
              data: { name: "date" },
              triggerType: "SAVE_2_LOCAL_STORAGE",
            },
          },
        },
        message: [],
        nextOptionsType: "AvailableTimes",
        key: "date_from_calendar",
        disablePlaceholerMessage: true,
        data: null,
      });

      return {
        nextReplies: {
          options,
          renderType: "boxView",
          optionsType: "AvailableDates4VideoTour",
          title: "",
          checkStorage: false,
          disableResetBox: false,
        },
        nextBotMessages: [{ message: "whichLiveVideoTourDate", speaker: "bot" }],
      };
    }
    case "AvailableTimes": {
      if (skip === "confirmation") {
        return {
          nextReplies: data,
          nextBotMessages: [{ message: "almostDoneFewMoreDetail", speaker: "bot" }],
        };
      }

      const times = _(data)
        .map((value) => value.replace("  ", " 0"))
        .uniq()
        .value();

      const options = [];

      const amTimeOptions = _(times)
        .filter((value) => moment(value, "YYYY-MM-DD HH:mm:ss A").format("a") === "am")
        .map((value, key) => ({
          content: {
            component: "NormalOptionTile",
            componentOptions: {
              icon: null,
              label: moment(value, "YYYY-MM-DD HH:mm:ss A").format("h:mm a"),
              isMorning: true,
              callbackOptions: {
                data: { data: value, name: "time" },
                triggerType: "SAVE_2_LOCAL_STORAGE",
              },
            },
          },
          nextOptionsType: "Form4ScheduleTour",
          message: [
            {
              message: moment(value, "YYYY-MM-DD HH:mm:ss A").format("ddd, MMM D, YYYY - h:mm a"),
              speaker: "user",
            },
          ],
          key: "tour time",
          event: "h_click",
          disablePlaceholerMessage: false,
          data: null,
        }))
        .value();

      const pmTimeOptions = _(times)
        .filter((value) => moment(value, "YYYY-MM-DD HH:mm:ss A").format("a") === "pm")
        .map((value, key) => ({
          content: {
            component: "NormalOptionTile",
            componentOptions: {
              icon: null,
              label: moment(value, "YYYY-MM-DD HH:mm:ss A").format("h:mm a"),
              isMorning: false,
              callbackOptions: {
                data: { data: value, name: "time" },
                triggerType: "SAVE_2_LOCAL_STORAGE",
              },
            },
          },
          nextOptionsType: "Form4ScheduleTour",
          message: [
            {
              message: moment(value, "YYYY-MM-DD HH:mm:ss A").format("ddd, MMM D, YYYY - h:mm a"),
              speaker: "user",
            },
          ],
          key: "tour time",
          event: "h_click",
          disablePlaceholerMessage: false,
          data: null,
        }))
        .value();

      if (amTimeOptions.length > 0) {
        options.push({
          content: {
            component: "SubTitleRow",
            componentOptions: { title: "morning" },
          },
          nextOptionsType: null,
          message: [],
          key: "morning_subtitle",
          event: "h_click",
          disablePlaceholerMessage: false,
          data: null,
        });

        options.push(...amTimeOptions);
      }

      if (pmTimeOptions.length > 0) {
        options.push({
          content: {
            component: "SubTitleRow",
            componentOptions: { title: "afternoon" },
          },
          nextOptionsType: null,
          message: [],
          key: "afternoon_subtitle",
          event: "h_click",
          disablePlaceholerMessage: false,
          data: null,
        });

        options.push(...pmTimeOptions);
      }

      if (times?.length > 7) {
        options.push({
          content: {
            component: "NormalOptionTile",
            componentOptions: {
              icon: null,
              label: "More...",
              callbackOptions: null,
            },
          },
          nextOptionsType: null,
          message: [],
          key: "more",
          event: "h_click",
          disablePlaceholerMessage: false,
          data: null,
        });
      }

      return {
        nextReplies: {
          options,
          renderType: "boxView",
          optionsType: "AvailableTimes",
          key: "amaTour",
          title: "",
          checkStorage: false,
          disableResetBox: false,
        },
        nextBotMessages: [{ message: "whichTimeWork", speaker: "bot" }],
      };
    }
    case "Form4ScheduleTour":
      return {
        nextReplies: data,
        nextBotMessages: [
          { message: state.property.enabled_schedule_a_tour ? resMessage ?? "almostDoneFewMoreDetail" : "noScheduleDetailGet", speaker: "bot" },
        ],
      };
    case "LikeTour":
    case "DisLikeTour":
    case "SkipTour":
    case "LikeContact":
    case "DisLikeContact":
    case "SkipContact":
      return {
        nextReplies: data,
        nextBotMessages: _.map(extraData.botMessages, (m) => ({
          message: m,
          speaker: "bot",
        })),
      };
    case "PostScheduleTour": {
      return {
        nextReplies: data,
        nextBotMessages: _.map(extraData.botMessages, (m) => ({
          message: m,
          speaker: "bot",
        })),
      };
    }
    case "SelfTour": {
      return {
        nextReplies: {
          ...data,
          options: data.options.map((o) => {
            if (o.content.component === "LinkOptionTile") {
              return {
                ...o,
                content: {
                  ...o.content,
                  componentOptions: {
                    ...o.content.componentOptions,
                    link: extraData,
                  },
                },
              };
            }

            return o;
          }),
        },
        nextBotMessages: [],
      };
    }
    case "Form4ContactUs":
      return {
        nextReplies: data,
        nextBotMessages: [{ message: resMessage?.trim() ? resMessage : "fewMoreDetailGet", speaker: "bot" }],
      };
    case "PostContactUs":
      return {
        nextReplies: data,
        nextBotMessages: _.map(extraData.botMessages, (m) => ({
          message: m,
          speaker: "bot",
        })),
      };
    case "VisitResidentPortal": {
      return {
        nextReplies: {
          ...data,
          options: data.options.map((o) => {
            if (o.content.component === "LinkOptionTile") {
              return {
                ...o,
                content: {
                  ...o.content,
                  componentOptions: {
                    ...o.content.componentOptions,
                    link: extraData,
                  },
                },
              };
            }

            return o;
          }),
        },
        nextBotMessages: [{ message: "wouldVisitResidentPortal", speaker: "bot" }],
      };
    }
    case "Photos": {
      const options = _(data)
        .keys()
        .filter((k) => !_.isEmpty(data[k]))
        .map((k) => ({
          content: {
            component: "NormalOptionTile",
            componentOptions: {
              label: k.toString(),
              icon: null,
              callbackOptions: null,
            },
          },
          nextOptionsType: "Gallery",
          message: [{ message: k, speaker: "user" }],
          key: k.toString().toLowerCase(),
          data: data,
          disablePlaceholerMessage: true,
        }))
        .valueOf();

      if (options.length > 0) {
        return {
          nextReplies: {
            options,
            title: null,
            optionsType: "Photos",
            renderType: "boxView",
            checkStorage: false,
            disableResetBox: false,
          },
          nextBotMessages: [{ message: "herePhotos", speaker: "bot" }],
        };
      }

      return {
        nextReplies: {
          options: _.filter(INITIAL_REPLY_OPTIONS, (o) => ["schedule_tour", "find_home"].includes(o.key)),
          title: "",
          renderType: "boxView",
          optionsType: "Photos",
          checkStorage: false,
          disableResetBox: false,
        },
        nextBotMessages: [{ message: "noPhotoWhatNext", speaker: "bot" }],
      };
    }
    case "Gallery":
      return {
        nextReplies: {
          options: [],
          title: null,
          optionsType: "Gallery",
          renderType: "galleryView",
          checkStorage: false,
          disableResetBox: false,
        },
        nextBotMessages: [],
      };
    case "CommunityInfo": {
      const policies = {};

      _.forEach(data, (value, key) => {
        if (key === "Overview" && value) {
          policies["Overview"] = {
            label: t("propertyOverview"),
            title: t("propertyOverview"),
            data: value,
          };
        } else if (key === "Apartment" && value) {
          policies["Features"] = {
            label: t("features"),
            title: t("appartmentFeat"),
            data: value,
          };
        } else if (key === "Community" && value) {
          policies["Amenities"] = {
            label: t("amenities"),
            title: t("communityAmenities"),
            data: value,
          };
        } else if (key === "Neighborhood" && value && value?.length > 0) {
          policies["Neighborhood"] = {
            label: t("neighborhood"),
            title: t("neighborhoodInfo"),
            data: _.compact(value),
          };
        } else if (key === "Parking" && value && value?.length > 0) {
          policies["Parking"] = {
            label: t("parkPolicy"),
            title: t("parkPolicyInfo"),
            data: _.compact(value),
          };
        } else if (key === "Pet" && value && value?.length > 0) {
          policies["Pet"] = {
            label: t("petPolicy"),
            title: t("petPolicyInfo"),
            data: _.compact(value),
          };
        } else if (key === "Office Hours" && value && value?.length > 0) {
          policies["Hours"] = {
            label: t("officeHours"),
            title: t("officeHourInfo"),
            data: _.compact(value),
          };
        } else if (key === "Promotion Offers" && !(!value.end_date && !value.start_date && !value.image_url && !value.description && !value.desclaimer)) {
          policies["Offer"] = {
            label: t("offer"),
            title: t("offerDetails"),
            data: value,
          };
        }
      });

      const overviewSection = policies["Overview"];

      delete policies["Overview"];

      const reorderedPolicies = overviewSection
        ? {
            Overview: overviewSection,
            ...policies,
          }
        : {
            ...policies,
          };

      store.dispatch(setPolicies(reorderedPolicies));

      store.dispatch(
        setBadgeSwitchItems(
          _(reorderedPolicies)
            .keys()
            .filter((k) => !_.isEmpty(reorderedPolicies[k].data))
            .map((k) => ({
              id: k.toLowerCase(),
              title: reorderedPolicies[k]["label"],
              label: k,
            }))
            .valueOf()
        )
      );

      const options = _(reorderedPolicies)
        .keys()
        .filter((k) => !_.isEmpty(reorderedPolicies[k].data))
        .map((k) => ({
          content: {
            component: "NormalOptionTile",
            componentOptions: {
              label: reorderedPolicies[k]["label"],
              icon: null,
              callbackOptions: null,
            },
          },
          nextOptionsType: "FeaturesView",
          message: [{ message: reorderedPolicies[k]["label"], speaker: "user" }],
          key: k.toString().toLowerCase(),
          data: k,
          disablePlaceholerMessage: true,
        }))
        .valueOf();

      if (options.length > 0) {
        return {
          nextReplies: {
            options,
            title: null,
            optionsType: "CommunityInfo",
            renderType: "boxView",
            checkStorage: false,
            disableResetBox: false,
          },
          nextBotMessages: [{ message: "hereCommunityInfo", speaker: "bot" }],
        };
      }

      return {
        nextReplies: {
          options: _.filter(INITIAL_REPLY_OPTIONS, (o) => ["schedule_tour", "find_home"].includes(o.key)),
          title: "",
          renderType: "boxView",
          optionsType: "CommunityInfo",
          checkStorage: false,
          disableResetBox: false,
        },
        nextBotMessages: [{ message: "noCommunityInfoWhatNext", speaker: "bot" }],
      };
    }
    case "FeaturesView":
      return {
        nextReplies: {
          options: [],
          title: null,
          optionsType: "FeaturesView",
          renderType: "featuresView",
          checkStorage: false,
          disableResetBox: false,
        },
        nextBotMessages: [],
      };
    case "Videos": {
      const processedData = {};

      _(data)
        .keys()
        .filter((k) => !_.isEmpty(data[k]))
        .forEach((k) => {
          const preData = data[k];
          const postData = preData.filter((d) => !_.isEmpty(d.url));

          if (postData.length > 0) {
            processedData[k] = postData;
          }
        });

      store.dispatch(setVideos(processedData));

      store.dispatch(
        setBadgeSwitchVideos(
          _(processedData)
            .keys()
            .filter((k) => !_.isEmpty(data[k]))
            .map((k) => ({
              id: k.toLowerCase(),
              title: k === "pre_recorded_video" ? "Video Tours" : k === "3d_video" ? "3D Tours" : k,
            }))
            .valueOf()
        )
      );

      const options = _(processedData)
        .keys()
        .filter((k) => !_.isEmpty(data[k]))
        .map((k) => ({
          content: {
            component: "NormalOptionTile",
            componentOptions: {
              label: k === "videos" ? "videoTours" : k,
              icon: null,
              callbackOptions: null,
            },
          },
          nextOptionsType: "VideosGallery",
          message: [{ message: k === "videos" ? "videoTours" : k, speaker: "user" }],
          key: k.toString().toLowerCase(),
          data: k,
          disablePlaceholerMessage: true,
        }))
        .valueOf();

      if (options.length > 0) {
        return {
          nextReplies: {
            options,
            title: null,
            optionsType: "Videos",
            renderType: "boxView",
            checkStorage: false,
            disableResetBox: false,
          },
          nextBotMessages: [{ message: "hereVideos", speaker: "bot" }],
        };
      }

      return {
        nextReplies: {
          options: _.filter(INITIAL_REPLY_OPTIONS, (o) => ["schedule_tour", "find_home", "contact_us"].includes(o.key)),
          title: "",
          renderType: "boxView",
          optionsType: "Videos",
          checkStorage: false,
          disableResetBox: false,
        },
        nextBotMessages: [{ message: "noVideoWhatNext", speaker: "bot" }],
      };
    }
    case "VideosGallery": {
      return {
        nextReplies: {
          options: [],
          title: null,
          optionsType: "VideosGallery",
          renderType: "videosGalleryView",
          checkStorage: false,
          disableResetBox: false,
        },
        nextBotMessages: [],
      };
    }
    case "FAQs":
      return {
        nextReplies: data,
        nextBotMessages: [],
      };
    case "DoIQualify":
      return {
        nextReplies: data,
        nextBotMessages: [{ message: qualification.question, speaker: "bot" }],
      };
    case "customButton": {
      const options = [..._.filter(INITIAL_REPLY_OPTIONS, (o) => ["schedule_tour", "contact_us"].includes(o.key)), EXPLORE_MORE_OPTION];

      return {
        nextReplies: {
          checkStorage: false,
          disableResetBox: true,
          options,
          optionsType: "customButton",
          title: "",
          renderType: "boxView",
        },
        nextBotMessages: [],
      };
    }
    case "EmbedMapView":
      return {
        nextReplies: INITIAL_REPLIES,
        nextBotMessages: [
          {
            message: resMessage || "Here is the map view:",
            speaker: "bot",
            subject: "embed_map_view",
          },
        ],
      };

    case "Init":
      return {
        nextReplies: data,
        nextBotMessages: [{ message: "howHelp", speaker: "bot", createdAt: new Date() }],
      };
    default:
      return {
        nextReplies: data,
        nextBotMessages: [{ message: "howHelp", speaker: "bot", createdAt: new Date() }],
      };
  }
};

function generateDynamicMessage(apiResponse, payload, defaultMsg = "floorMatchPref2nd") {
  const { buffer_search, filter_excluded } = apiResponse || {};
  const { bedroom_preference, price_preference, desired_move_in_date } = payload || {};

  const defaultResponse = defaultMsg || "floorMatchPref2nd";

  const excludedFilters = (filters) => Array.isArray(filter_excluded) && filters.every((filter) => filter_excluded.includes(filter));

  const none = !desired_move_in_date && !price_preference && !bedroom_preference;
  const budgetOnly = price_preference && !desired_move_in_date && !bedroom_preference;
  const moveInOnly = desired_move_in_date && !price_preference && !bedroom_preference;
  const bedroomOnly = bedroom_preference && !desired_move_in_date && !price_preference;
  const allPreferences = desired_move_in_date && bedroom_preference && price_preference;
  const bedroomAndPrice = bedroom_preference && price_preference && !desired_move_in_date;
  const budgetAndMoveIn = desired_move_in_date && price_preference && !bedroom_preference;
  const bedroomAndMoveIn = desired_move_in_date && bedroom_preference && !price_preference;

  if (buffer_search === true && filter_excluded?.length === 0) {
    switch (true) {
      case moveInOnly:
        return "3a_buffer_search_no_filters_desired_move_in";

      case bedroomAndMoveIn:
        return "3a_buffer_search_no_filters_bedroom_desired_move_in";

      case budgetAndMoveIn:
        return "3a_buffer_search_no_filters_budget_desired_move_in";

      case allPreferences:
        return "3a_buffer_search_no_filters_all_preferences";

      default:
        return defaultResponse;
    }
  } else if (buffer_search === false && filter_excluded?.length === 0) {
    switch (true) {
      case bedroomOnly:
        return "2_bedroom_only";

      case budgetOnly:
        return "2_budget_only";

      case moveInOnly:
        return "2_move_in_only";

      case bedroomAndPrice:
        return "2_bedroom_and_price";

      case bedroomAndMoveIn:
        return "2_bedroom_and_move_in";

      case budgetAndMoveIn:
        return "2_budget_and_move_in";

      case allPreferences:
        return "2_all_preferences";

      case none:
        return "floorMatchPref";

      default:
        return defaultResponse;
    }
  } else if (excludedFilters(["bedroom_type", "price_range", "desired_move_in"])) {
    switch (true) {
      case allPreferences:
        return "3d_buffer_search_bedroom_pref_move_in_price";

      default:
        return defaultResponse;
    }
  } else if (buffer_search === false && excludedFilters(["price_range", "bedroom_type"])) {
    switch (true) {
      case allPreferences:
        return "3c1_move_in_date_bedroom_budget";

      case bedroomAndPrice:
        return "3c1_no_move_in_date_bedroom_budget";

      default:
        return defaultResponse;
    }
  } else if (buffer_search === true && excludedFilters(["price_range", "bedroom_type"])) {
    switch (true) {
      case allPreferences:
        return "3c2_move_in_date_bedroom_budget_timeline";

      default:
        return defaultResponse;
    }
  } else if (buffer_search === false && excludedFilters(["price_range"])) {
    switch (true) {
      case budgetOnly:
        return "3b1_no_move_in_no_bedroom_budget";

      case bedroomAndPrice:
        return "3b1_no_buffer_bedroom_budget";

      case budgetAndMoveIn:
        return "3b1_move_in_budget_no_bedroom";

      case allPreferences:
        return "3b1_move_in_budget_bedroom";

      default:
        return defaultResponse;
    }
  } else if (buffer_search === true && excludedFilters(["price_range"])) {
    switch (true) {
      case budgetAndMoveIn:
        return "3b2_desired_move_in_no_bedroom_with_budget";

      case allPreferences:
        return "3b2_desired_move_in_with_bedroom_and_budget";

      default:
        return defaultResponse;
    }
  } else if (buffer_search === false && excludedFilters(["bedroom_type"])) {
    switch (true) {
      case bedroomAndMoveIn:
        return "3c2_no_buffer_search_bedroom_preference_timeline";

      case allPreferences:
        return "3c2_no_buffer_search_bedroom_budget_timeline";

      case bedroomOnly:
        return "3c2_no_buffer_search_bedroom_preference_general";

      case bedroomAndPrice:
        return "3c2_no_buffer_search_bedroom_preference_budget";

      default:
        return defaultResponse;
    }
  } else if (buffer_search === true && excludedFilters(["bedroom_type"])) {
    switch (true) {
      case bedroomAndMoveIn:
        return "3c2_buffer_search_bedroom_pref_timeline_no_price";

      default:
        return defaultResponse;
    }
  } else {
    return defaultResponse;
  }
}

export const sortedByDate = (a, b) => {
  const dateA = new Date(a.createdAt);
  const dateB = new Date(b.createdAt);

  return dateA - dateB;
};

export const validator = (data, type) => {
  switch (type) {
    case "EMAIL":
      return data.length > 0 && /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})(:[a-z0-9]+)?$/i.test(data);
    case "PHONE":
      return data.length > 0 && /^\(\d{3}\) \d{3}-\d{4}$/.test(data);
    case "TEXT_ONLY":
      return data.length > 0 && /^[a-zA-Z\s-]+$/.test(data);
    default:
      return true;
  }
};

export const fetchMascotSettings = async (propertyId) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", "myhyly-hyblast-sync");
  myHeaders.append("Content-Type", "application/json");

  const graphql = JSON.stringify({
    query: `
      query MascotSettings($propertyId: ID!) {
        mascot(propertyId: $propertyId) {
          mascotSetting {
            colors {
              primary
              secondary
              tertiary
            }
            icon
            iconUrl
            animation
            quickActions
            welcomeMessage
            firstMessage
            bubbleType
            disclaimer
          }
        }
      }
    `,
    variables: { propertyId },
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow",
  };

  return await fetch(`${process.env.REACT_APP_CRM_BASE_URL}/graphql`, requestOptions);
};

export const fetchGtmId = (encoded_property_id) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", "myhyly-hyblast-sync");
  myHeaders.append("Content-Type", "application/json");

  const graphql = JSON.stringify({
    query: `query getGtmIdQuery($propertyId: ID!) {\n  websiteGtmScript(\n    propertyId: $propertyId \n  ) {\n    id\n      noscript\n        script\n       hytoursScript\n }\n  }\n`,
    variables: { propertyId: `${encoded_property_id}` },
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow",
  };

  return fetch(`${process.env.REACT_APP_CRM_BASE_URL}/graphql`, requestOptions);
};

export const getConversationId = (appSSID) => {
  const propertyInfo = store?.getState()?.property;
  const propertyId = propertyInfo?.property_id || "";
  const email = propertyInfo?.email || localStorage.getItem(`${propertyId}-email`) || "";
  const entryId = propertyInfo?.entry_id || localStorage.getItem(`${propertyId}-entry_id`) || "";
  const date = moment().format("YYYY-MM-DD h:mm:ss");

  const myHeaders = new Headers();
  myHeaders.append("Authorization", "myhyly-hyblast-sync");
  myHeaders.append("Content-Type", "application/json");

  const graphql = JSON.stringify({
    query: `mutation{\n  createHayleyConversation(input: {\n    propertyId: "${propertyId}",\n    startAt: "${date}",\n    sessionId: "${appSSID}",\n    entryId: "${entryId}",\n    email: "${email}"\n  }) {\n  hayleyConversation{\n    id\n   }\n}\n}`,
    variables: {},
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow",
  };

  return fetch(`${process.env.REACT_APP_CRM_BASE_URL}/graphql`, requestOptions);
};

export const initConversationWithMessages = (SSID, questionMsgs = [], answerMsgs = []) => {
  const questionMsg = questionMsgs[0];
  const answerMsg = answerMsgs[0];

  getConversationId(SSID)
    .then((res) => res.json())
    .then((res) => {
      const conversationId = res?.data?.createHayleyConversation?.hayleyConversation?.id || null;
      store.dispatch(setConversationID(conversationId));

      if (questionMsg?.message) {
        sendHayleyMessage({
          text: t(questionMsg.message),
          queryType: "question",
          ownerType: "prospect",
          kgNodeValue: questionMsg.message === "findHome" ? "unit availability" : t(questionMsg.message),
          conversationId,
        });
      }

      if (answerMsg?.message) {
        sendHayleyMessage({
          text: t(answerMsg.message),
          queryType: "answer",
          ownerType: "agent",
          kgNodeValue: t(answerMsg.message),
          conversationId,
        });
      }
    })
    .catch((err) => {
      console.error("initConversationWithMessages error:", err);
    });
};

export const getHayleyChatDisclaimer = (orgId, propertyId) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", "myhyly-hyblast-sync");
  myHeaders.append("Content-Type", "application/json");

  const graphql = JSON.stringify({
    query: `
      query gethayleyChatDisclaimerQuery($orgId: ID!, $propertyId: ID!) {
        hayleyChatDisclaimer(orgId: $orgId, propertyId: $propertyId) {
          orgLevelDisclaimer
          orgLevelDisclaimerEnabled
          propertyLevelDisclaimer
          propertyLevelDisclaimerEnabled
          disclaimerType
        }
      }
    `,
    variables: {
      orgId,
      propertyId,
    },
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow",
  };

  return fetch(`${process.env.REACT_APP_CRM_BASE_URL}/graphql`, requestOptions);
};

export const updateHayleyConversation = (entryId) => {
  const conversationId = store?.getState()?.window?.conversationID || "";

  const myHeaders = new Headers();
  myHeaders.append("Authorization", "myhyly-hyblast-sync");
  myHeaders.append("Content-Type", "application/json");

  const graphql = JSON.stringify({
    query: `mutation{\n  updateHayleyConversation(input: {\n    id: "${conversationId}",\n    entryId: "${entryId}"\n  }) {\n  hayleyConversation{\n    id\n   }\n}\n}`,
    variables: {},
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow",
  };

  return fetch(`${process.env.REACT_APP_CRM_BASE_URL}/graphql`, requestOptions);
};

export const retrieveConversation = (appSSID, pagination, propertyId) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", "myhyly-hyblast-sync");
  myHeaders.append("Content-Type", "application/json");

  const graphqlQuery = {
    query: `query RetrieveHayleyConversation($sessionId: String!, $params: Json, $propertyId: String!) {
        retrieveHayleyConversation(
            sessionId: $sessionId,
            params: $params,
            propertyId: $propertyId
        ) {
            id
            propertyId
            messagesCount
            messages {
                propertyId
                text
                queryType
                createdAt
                id
                feedback
            }
            numberOfTokens
            startAt
            endAt
            summary
            sessionId
            outcome
            entryId
        }
    }`,
    variables: {
      sessionId: appSSID,
      params: pagination,
      propertyId,
    },
  };

  const graphql = JSON.stringify(graphqlQuery);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow",
  };

  return fetch(`${process.env.REACT_APP_CRM_BASE_URL}/graphql`, requestOptions);
};

export const saveConversationFeedback = (conId, feedback = "skip", toolName = "contact_us") => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", "myhyly-hyblast-sync");
  myHeaders.append("Content-Type", "application/json");

  const graphql = JSON.stringify({
    query: `mutation{\n  saveConversationFeedback(input: {\n    coversationId: "${conId}",\n   feedback: "${feedback}"\n    toolName: "${toolName}",\n  }) {\n  response \n}\n}`,
    variables: {},
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow",
  };

  return fetch(`${process.env.REACT_APP_CRM_BASE_URL}/graphql`, requestOptions);
};

export const translationStatus = (status) => {
  store.dispatch(setTransStatus(status));
};

export const getTranslations = (category) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", "myhyly-hyblast-sync");
  myHeaders.append("Content-Type", "application/json");

  const graphql = JSON.stringify({
    query: `query translationsQuery {
      getTranslations(category: "${category}") {
        english
        spanish
        key
      }
    }`,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow",
  };

  return fetch(`${process.env.REACT_APP_CRM_BASE_URL}/graphql`, requestOptions);
};

export const saveHayleyChatbotFeedback = (params) => {
  const { message, feedback, propertyId, page, email } = params;
  const myHeaders = new Headers();
  myHeaders.append("Authorization", "myhyly-hyblast-sync");
  myHeaders.append("Content-Type", "application/json");

  let query = `mutation{\n  saveHayleyChatbotFeedback(input: {\n    message: "${message}",\n   feedback: "${feedback}",\n   org_id: "${propertyId}"\n }) {\n  response \n}\n}`;

  if (page === "feedback") {
    let conventionalFeed = "thumbs_up";

    if (feedback === "complaint" || feedback === "negative_feedback") {
      conventionalFeed = "thumbs_down";
    }

    query = `mutation{\n  saveHayleyChatbotFeedback(input: {\n    message: "${message}",\n   feedback: "${conventionalFeed}",\n   feedback_type: "${feedback}",\n   email: "${email}",\n   originator: "mail",\n   org_id: "${propertyId}"\n }) {\n  response \n}\n}`;
  }

  const graphql = JSON.stringify({
    query,
    variables: {},
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow",
  };

  return fetch(`${process.env.REACT_APP_CRM_BASE_URL}/graphql`, requestOptions);
};

export const createEventSignal = (data) => {
  const { propertyId, tag, appSubsection, metric, sessionId, entryId, metaData } = data;
  const myHeaders = new Headers();
  myHeaders.append("Authorization", "myhyly-hyblast-sync");
  myHeaders.append("Content-Type", "application/json");

  const graphql = JSON.stringify({
    query: `mutation{
      trackHayleySignal(input: {
        sessionId: "${sessionId}",
        entryId: "${entryId}",
        tag: "${tag}",
        appSubsection: "${appSubsection}",
        metric: "${metric}",
        propertyId: "${propertyId}",
        responseTime: "0.21",
        processingTime: "0.11",
        statusCode: "200",
        statusMessage: "",
        metadata: "${metaData || "{}"} ",
      }) {
        success
      }
    }`,
    variables: {},
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow",
  };

  return fetch(`${process.env.REACT_APP_CRM_BASE_URL}/graphql`, requestOptions);
};

export const createHayleyMessage = (data, ignore = false) => {
  if (ignore) {
    return Promise.resolve({
      json: () => Promise.resolve({ ignored: true }),
    });
  }

  const { conversationId, propertyId, text, queryType, ownerType, appName, kgNodes = [] } = data;

  const myHeaders = new Headers();
  myHeaders.append("Authorization", "myhyly-hyblast-sync");
  myHeaders.append("Content-Type", "application/json");

  const kgNodesString = kgNodes
    .map((node) => {
      const fields = Object.entries(node)
        .map(([key, value]) => `${key}: "${String(value).toLowerCase().replace(/"/g, '\\"')}"`)
        .join(", ");

      return `{ ${fields} }`;
    })
    .join(", ");

  const graphqlQuery = `
    mutation {
      createHayleyMessage(input: {
        conversationId: "${conversationId}",
        propertyId: "${String(propertyId)}",
        text: "${text.replace(/"/g, '\\"')}",
        queryType: "${queryType}",
        ${ownerType ? `ownerType: "${ownerType}",` : ""}
        appName: "${appName}",
        kgNodes: [ ${kgNodesString} ]
      }) {
        hayleyMessage {
          id
          text
          questionId
          sequenceId
          ownerType
          queryType
          propertyId
          propertyName
          orgId
          orgName
          conversation {
            id
            messagesCount
          }
        }
      }
    }
  `;

  const graphql = JSON.stringify({
    query: graphqlQuery,
    variables: {},
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow",
  };

  return fetch(`${process.env.REACT_APP_CRM_BASE_URL}/graphql`, requestOptions);
};

export const sendHayleyMessage = ({ text, queryType, ownerType, kgNodeValue }) => {
  if (!text) {
    return;
  }

  const propertyId = store.getState().property.property_id || "";
  const conversationID = store.getState().window.conversationID || "";

  const conversationId = conversationID || "";

  const kgNodes = queryType === "question" && kgNodeValue ? [{ l0_subject: kgNodeValue }] : [];

  createHayleyMessage({
    conversationId,
    propertyId,
    text,
    queryType,
    ownerType,
    appName: "HayleyChat",
    kgNodes,
  }).then((res) => res.json());
};

export const createItemRecord = (propertyId, sessionId, toolName, entryIdParam) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", "myhyly-hyblast-sync");
  myHeaders.append("Content-Type", "application/json");

  const clickAt = moment().format("YYYY-MM-DD h:mm:ss");

  const urlParams = new URLSearchParams(window.location.search);
  const isJAI = urlParams.get("isjai");

  const fallbackEntryId = store?.getState()?.property?.entry_id || localStorage.getItem(`${propertyId}-entry_id`) || "";
  const entryId = entryIdParam || fallbackEntryId;

  const graphql = JSON.stringify({
    query: `mutation{\n  createHayleyItemRecord(input: {\n    propertyId: "${propertyId}",\n   sessionId: "${sessionId}"\n    toolName: "${toolName}",\n   clickAt: "${clickAt}",\n   entryId: "${entryId}",\n   propertyWebsite: ${!isJAI}\n   }) {\n  success \n}\n}`,
    variables: {},
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow",
  };

  return fetch(`${process.env.REACT_APP_CRM_BASE_URL}/graphql`, requestOptions);
};

export const conversationFeedBack = (messageId, like) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", "myhyly-hyblast-sync");
  myHeaders.append("Content-Type", "application/json");

  const graphql = JSON.stringify({
    query: `mutation{\n  saveHayleyMessageFeedback(input: {\n    id: "${messageId}",\n   feedback: "${
      like || ""
    }"\n   }) {\n  hayleyMessage{\n    text\n    feedback\n    ownerType\n    queryType\n      propertyId\n    propertyName\n    orgId\n    orgName\n     conversation{\n      id\n    messagesCount\n    sessionId\n    entryId\n    }\n  }\n}\n}`,
    variables: {},
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow",
  };

  return fetch(`${process.env.REACT_APP_CRM_BASE_URL}/graphql`, requestOptions);
};

export const getSubjectFromNextOptionType = (nextOptionType, kgNodeValue) => {
  const findHomeTypes = ["BedroomTypes", "PriceBrackets", "WhenMoveIn", "Units"];
  const feedbackTypes = ["LikeTour", "DisLikeTour", "SkipTour", "LikeContact", "DisLikeContact", "SkipContact"];

  switch (true) {
    case findHomeTypes.some((type) => nextOptionType.includes(type)):
      return "unit availability";

    case nextOptionType === "Form4ScheduleTour" || nextOptionType === "PostScheduleTour":
      return "Schedule a tour";

    case nextOptionType === "Form4ContactUs" || nextOptionType === "PostContactUs":
      return "Contact me";

    case nextOptionType === "VisitResidentPortal":
      return "Visit Resident Portal";

    case feedbackTypes.some((type) => nextOptionType.includes(type)):
      return "Feedback";

    case nextOptionType === "DoIQualify":
      return "do i qualify";

    default:
      return kgNodeValue;
  }
};

export const getMascotColors = (mascotSettings) => {
  if (mascotSettings?.icon.includes("_0")) {
    return {
      backgroundFill: mascotSettings?.colors?.secondary,
      frontFill: mascotSettings?.colors?.primary,
    };
  } else if (mascotSettings?.icon.includes("_1")) {
    return {
      backgroundFill: mascotSettings?.colors?.primary,
      frontFill: mascotSettings?.colors?.secondary,
    };
  } else if (mascotSettings?.icon.includes("_2")) {
    return {
      backgroundFill: mascotSettings?.colors?.secondary,
      frontFill: "#FFFFFF",
    };
  } else if (mascotSettings?.icon.includes("_3")) {
    return {
      backgroundFill: mascotSettings?.colors?.primary,
      frontFill: "#FFFFFF",
    };
  } else if (mascotSettings?.icon.includes("_4")) {
    return {
      backgroundFill: mascotSettings?.colors?.primary,
      frontFill: "#FFFFFF",
    };
  } else if (mascotSettings?.icon.includes("_5")) {
    return {
      backgroundFill: "#FFFFFF",
      frontFill: mascotSettings?.colors?.primary,
    };
  } else if (mascotSettings?.icon.includes("_6")) {
    return {
      backgroundFill: mascotSettings?.colors?.primary,
      frontFill: "#555555",
    };
  } else if (mascotSettings?.icon.includes("_7")) {
    return { backgroundFill: "#555555", frontFill: "#FFFFFF" };
  }

  return {
    backgroundFill: mascotSettings?.colors?.secondary,
    frontFill: mascotSettings?.colors?.primary,
  };
};

export const renderMascot = (mascotSettings, position, flipped, customSize, isAnimated) => {
  if (mascotSettings?.icon?.includes("friendly")) {
    return (
      <FriendlyBot
        width={customSize ? customSize.width : position && position === "sticky-right" ? "32" : "80"}
        height={customSize ? customSize.height : position && position === "sticky-right" ? "32" : "72"}
        sWidth={customSize ? customSize.sWidth : position && position === "sticky-right" ? "30" : "72"}
        sHeight={customSize ? customSize.sHeight : position && position === "sticky-right" ? "14" : "18"}
        {...getMascotColors(mascotSettings)}
        flipped={position === "bottom-left" || flipped}
        isAnimated={isAnimated}
      />
    );
  } else if (mascotSettings?.icon?.includes("hayley")) {
    return (
      <TheHayley
        width={customSize ? customSize.width : position && position === "sticky-right" ? "32" : "80"}
        height={customSize ? 30 : position && position === "sticky-right" ? "26" : "72"}
        {...getMascotColors(mascotSettings)}
        isAnimated={isAnimated}
      />
    );
  } else if (mascotSettings?.icon?.includes("minimalist")) {
    return (
      <TheMinimalist
        width={customSize ? customSize.width : position && position === "sticky-right" ? "32" : "81"}
        height={customSize ? customSize.height : position && position === "sticky-right" ? "32" : "81"}
        {...getMascotColors(mascotSettings)}
        flipped={position === "bottom-left" || flipped}
        isAnimated={isAnimated}
      />
    );
  }

  return null;
};

export const hayleyAnimation = (animationName) => {
  if (animationName === "pulse") {
    return "pulse";
  } else if (animationName === "pop") {
    return "pop";
  } else if (animationName === "bounce") {
    return "bounce";
  } else if (animationName === "wiggle") {
    return "wiggle";
  }

  return "none";
};

export const areQuickActionsEmpty = (mascotSettings) => {
  if (!mascotSettings?.quickActions) {
    return true;
  }

  const quickActionsEmpty = mascotSettings?.quickActions?.every((action) => action === "");

  return quickActionsEmpty || mascotSettings?.quickActions?.length === 0;
};

export const convertToTitleCase = (input, exceptions = ["the", "and", "an", "to", "a"]) => {
  if (!input) {
    return "";
  }

  let words = input.replace(/_/g, " ");
  words = words.toLowerCase().split(/\s+/);

  const titleWords = words.map((word, index) => {
    if (index === 0 || !exceptions.includes(word)) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }

    return word;
  });

  return titleWords.join(" ");
};

export const ACTION_KEYS = {
  find_a_home: "find_home",
  schedule_a_tour: "schedule_tour",
};

export const SHOW_ACTION_KEYS = {
  find_a_home: "findHome",
  schedule_a_tour: "scheduleTour",
  contact_us: "contactMe",
  photos: "photos",
  videos: "videos",
  community_info: "communityInfo",
  visit_resident_portal: "residentalPortal",
};

export const isQaEnvironment = () => {
  return process.env.REACT_APP_CRM_BASE_URL.includes("qa.hyly.us") || window.location.host.includes("localhost");
};

export const getDateString = (date) => {
  if (!moment(date).isValid() || !date) {
    return "- -";
  }

  if (moment(date).isBefore(moment().startOf("day"))) {
    return t("availableNow");
  }

  if (moment(date).isSame(moment(), "day")) {
    return t("fromToday");
  }

  if (moment(date).isSame(moment().add(1, "day"), "day")) {
    return t("fromTomorrow");
  }

  return t("fromDate", { date: moment(date).format("DD MMM YYYY") });
};

export const convertGifToPng = async (gifImageSource) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = gifImageSource;

    img.onload = function () {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      const staticImageData = canvas.toDataURL("image/png");

      resolve(staticImageData);
    };

    img.onerror = function () {
      reject(new Error("Failed to load the GIF image."));
    };
  });
};

export const checkTranslation = (arr) => {
  if (!arr?.length) {
    return [];
  }

  const res = arr.map((v) => {
    const checkLoader = loaders.includes(v.message);

    let loaderMsg = null;

    if (checkLoader) {
      const spliting = t(v.message)?.split(" ");

      if (spliting.length > 1) {
        const displayParts = spliting.slice(0, -1);

        loaderMsg =
          `<div class="hayley-inline-block">${displayParts.join(" ")}</div>` +
          " " +
          `<div class="hayley-inline-block">${spliting[spliting.length - 1].replace("{{dotLoader}}", ` ${dotLoader}`)}</div>`;
      } else {
        loaderMsg = `<div class="hayley-inline-block">${spliting[spliting.length - 1].replace("{{dotLoader}}", ` ${dotLoader}`)}</div>`;
      }
    }

    const value = checkLoader ? loaderMsg : t(v.message);

    return { ...v, message: value };
  });

  return res;
};

export const addUTMScript = (noscriptString, scriptString, hytoursScript) => {
  if (noscriptString || scriptString || hytoursScript) {
    if (scriptString) {
      var script = document.createElement("script");
      script.src = "";
      let dataScript = scriptString.split("script>");
      let fun = dataScript[1].split(";</");
      script.innerHTML = fun[0];
      document.head.appendChild(script);
    }

    if (hytoursScript) {
      console.info("hytoursScript", hytoursScript);

      var hytoursScriptElement = document.createElement("script");
      const scriptRegex = /<script[^>]*>([\s\S]*?)<\/script>/g;

      const scriptMatches = [...hytoursScript.matchAll(scriptRegex)];

      let combinedScript = "";
      for (const match of scriptMatches) {
        combinedScript += match[1].trim();
      }
      hytoursScriptElement.textContent = combinedScript;
      document.head.appendChild(hytoursScriptElement);
    }

    if (noscriptString) {
      let rootDiv = document.getElementById("hayley-area");
      var noscript = document.createElement("noscript");
      let data = noscriptString.split("iframe");
      noscript.innerHTML = `<iframe` + data[1] + `iframe>`;
      document.body.insertBefore(noscript, rootDiv);
    }
  }
};

export const convertToCamelCase = (inputString) => {
  return inputString.replace(/_([a-z])/g, function (match, p1) {
    return p1.toUpperCase();
  });
};

export const restartChatHandle = () => {
  store.dispatch(updateFaq(false));
  //store.dispatch(setFilterOptions([]));
  store.dispatch(setShowLangChange(true));
  store.dispatch(setActiveOptionComp(null));
  store.dispatch(setShowAllOptions(false));
  store.dispatch(moveToTop());
  store.dispatch(loadInitialMessages());
  store.dispatch(restartMessagesWithLastOnly());

  getNextOptions("Init")
    .then((res) => {
      const { nextReplies } = makeNextOptions("Init", res.data, res.extraData || undefined);

      store.dispatch(setReplies(nextReplies));
      store.dispatch(setOptionsTypeLogs([]));
    })
    .catch((err) => {
      /** @todo Add error handling part */
    });
};

export const getFormattedDisclaimer = (data) => {
  let parsedData = { title: "", message: "", message_es: "" };
  try {
    let cleaned = data.replaceAll("=>", ":");
    cleaned = cleaned.replace(/\\([^"\\bfnrtu0-9])/g, "$1");
    parsedData = JSON.parse(cleaned);
  } catch (err) {
    console.error("Failed to parse disclaimer:", err);
  }

  return "title" in parsedData ? parsedData : { title: "", message: "", message_es: "" };
};

// export const errorReqReplies = () => {
//   const errorMessage = [{ message: "flowErrorMessage", speaker: "bot" }];

//   const allMessages = store.getState().messages.messages;

//   const findActiveMessage = allMessages?.find((v) => v.optionsType && v.optionsType === "Init");

//   const findKey = findActiveMessage?.key || null;

//   const replyOptions = [
//     // { ...RETRY_OPTION, data, nextOptionsType, message: messages },
//     { ...EXPLORE_MORE_OPTION, data: findKey },
//   ];

//   const reply = { ...RETRY_OPTION_REPLIES, options: replyOptions };

//   store.dispatch(addNewMessage(errorMessage));

//   store.dispatch(setReplies(reply));
// };

export const formatMessageEdit = (type = "Init", label = null, from = null) => {
  const propertyId = store.getState().property.property_id || "";
  const conversationID = store.getState().window.conversationID || "";

  const isTriggerHayleyMessage = type && HAYLEY_MESSAGE_EDIT_TYPES.includes(type) && from && HAYLEY_EXTRA_OPTION_SOURCES.includes(from);

  if (isTriggerHayleyMessage) {
    createHayleyMessage({
      conversationId: conversationID || "",
      propertyId,
      text: t(label) || "",
      queryType: "question",
      ownerType: "prospect",
      appName: "HayleyChat",
      kgNodes: [{ l0_subject: type === "BedroomTypes" ? "unit availability" : t(label) }],
    }).then((res) => res.json());
  }

  store.dispatch(setActiveOptionComp(null));
  store.dispatch(setShowAllOptions(false));

  getNextOptions(type)
    .then((res) => {
      const { nextReplies, nextBotMessages } = makeNextOptions(type, res.data, res.extraData || undefined);

      const labelMsg = label
        ? [{ message: label, createdAt: new Date(), speaker: "user", optionsType: defaultEditFormats.includes(type) ? "Init" : null }]
        : [];

      store.dispatch(filterEditMessages([...labelMsg, ...nextBotMessages]));

      const options = nextReplies?.options?.filter((o) => from !== o.key);

      store.dispatch(setReplies({ ...nextReplies, options }));
      store.dispatch(setOptionsTypeLogs(store.getState().replies.optionsTypeLogs?.slice(0, -1)));

      const allMsgs = [...labelMsg, ...nextBotMessages];
      const lastMsg = allMsgs[allMsgs.length - 1];

      if (((type === "Init" && (from === "formCancel" || from === "feedbackCancel")) || isTriggerHayleyMessage) && lastMsg) {
        createHayleyMessage({
          conversationId: conversationID,
          propertyId,
          text: t(lastMsg.message) || "",
          queryType: "answer",
          ownerType: "agent",
          appName: "HayleyChat",
          kgNodes: [],
        }).then((res) => res.json());
      }
    })
    .catch((err) => {
      console.error("error formatMessageEdit", err);

      /** @todo Add error handling part */
    });
};

export const loadFaqChat = (ssid, pagination = { page: 1, per_page: 20 }, propertyId) => {
  return retrieveConversation(ssid, pagination, propertyId)
    .then((response) => response.json())
    .then((res) => {
      if (res?.data) {
        const messages = res.data?.retrieveHayleyConversation?.messages?.map((v, i) => {
          const speaker = v.queryType == "question" ? "user" : "hyly";

          const linksHandle = speaker == "hyly" ? detectAndGenerateLinks(v.text) : v.text;

          const message = {
            message: linksHandle,
            feedback: v.feedback || null,
            id: v.id || null,
            speaker,
            createdAt: v.createdAt,
          };

          return message;
        });

        return messages;
      }
    })
    .catch((err) => {
      console.error("error loadFaqChat", err);
      throw err; // Re-throw the error to propagate it further if needed
    });
};

export const addOptionMsg = (type = "Init", message = []) => {
  store.dispatch(setActiveOptionComp(null));

  store.dispatch(addNewMessage([{ message: `typing`, speaker: "bot", createdAt: new Date() }]));
  store.dispatch(setIsDisabled(true));

  getNextOptions(type)
    .then((res) => {
      store.dispatch(removeAndAddMessages([]));

      if (res?.data?.floor_plans && !["UnitsAll", "UnitsByRoom", "Units"].includes(type)) {
        type = "UnitsAll";
      }

      const { nextReplies, nextBotMessages } = makeNextOptions(type, res.data, res.extraData || undefined);

      const options = nextReplies?.options;

      let duplicateMessages = [...message, ...nextBotMessages] || [];
      let newMessages = [];

      duplicateMessages?.forEach((msg) => {
        let message = { ...msg, createdAt: new Date().toISOString() };
        newMessages.push(message);
      });

      if (["unitView"].includes(nextReplies?.renderType)) {
        newMessages.push({
          key: compMsgKeys[nextReplies?.renderType] || nextReplies?.renderType,
          speaker: "comp",
          replies: nextReplies,
          createdAt: new Date().toISOString(),
        });
      }

      store.dispatch(setIsDisabled(false));
      store.dispatch(addNewMessage(newMessages));
      store.dispatch(setReplies({ ...nextReplies, options }));
      store.dispatch(setOptionsTypeLogs(store.getState().replies.optionsTypeLogs?.slice(0, -1)));
    })
    .catch((err) => {
      console.error("error formatMessageEdit", err);
      store.dispatch(setIsDisabled(false));
      /** @todo Add error handling part */
    });
};

export const isFirstCall = (() => {
  let isFirst = true;

  return (reset = false) => {
    if (reset) {
      isFirst = true;

      return true;
    }

    if (isFirst) {
      setTimeout(() => {
        isFirst = true;
      }, 3000);

      isFirst = false;

      return true;
    }

    return isFirst;
  };
})();

export const ALL_CHAT_SUBJECTS = [
  "agent_handoff",
  "do i qualify",
  "unit availability",
  "schedule a tour",
  "photos",
  "videos",
  "resident portal",
  "contact us",
  "positive feedback",
  "negative feedback",
  "unsatisfactory answer",
  "schedule",
  "neighborhood",
  "neighborhood summary",
  "neighborhood_summary",
  "contact",
  "contact_summary",
  "cancel_inquiry",
  "embed_map_view",
  "esp_not_enabled",
];

export const NEGATIVE_SUBJECTS = [
  "negative sentiment",
  "family-friendly housing",
  "gender inclusiveness",
  "community security",
  "cultural inclusivity",
  "accessibility features",
  "prompt injection",
  "seeking clarification",
  "complaint filing",
  "off topic questions",
  "unsatisfactory answer",
];

export const formatTimestamp = (timestamp) => {
  const today = moment().startOf("day");
  const messageDay = moment(timestamp).startOf("day");

  if (today.isSame(messageDay, "day")) {
    return "Today";
  } else if (today.subtract(1, "days").isSame(messageDay, "day")) {
    return "Yesterday";
  }

  return moment(timestamp).format("MMM DD, YYYY");
};

export const isMarkdown = (str) => {
  const markdownRegex = /(\s*[-_*]{3,}\s*)|(^#+\s)|(\[.*?\]\(.*?\))|(```[\s\S]*?```)|(`[^`]*?`)|(^>\s)|(^-\s|\*\s|\+\s)/gm;

  return markdownRegex.test(str);
};

export const extractUniqueDates = (data) => {
  const uniqueDates = new Set();

  data.forEach((item) => {
    const date = item.time_slot.split(" ")[0];
    uniqueDates.add(date);
  });

  return Array.from(uniqueDates);
};

export const filterByDate = (data, givenDate) => {
  if (!data || !Array.isArray(data)) {
    return [];
  }

  return data.filter((item) => {
    const date = moment(item.time_slot, "YYYY-MM-DD hh:mm:ss A").format("YYYY-MM-DD"); // Ensure consistent format for Safari compatibility

    return date === givenDate;
  });
};

export const findTimeSlot = (time, timeArray) => {
  const givenTime = moment(time, "YYYY-MM-DD hh:mm:ss A"); // Explicitly format the date

  const foundSlot = timeArray.find((slot) => {
    const slotTime = moment(slot.time_slot, "YYYY-MM-DD hh:mm:ss A");

    return givenTime.isSame(slotTime);
  });

  return foundSlot ? foundSlot.time_slot : "";
};

export const getAmPmSlotsSeparated = (data) => {
  const amTimeSlots = data.filter(({ value }) => moment(value, "YYYY-MM-DD hh:mm:ss A").format("a") === "am"); // Fix formatting string for Safari
  const pmTimeSlots = data.filter(({ value }) => moment(value, "YYYY-MM-DD hh:mm:ss A").format("a") === "pm");

  return {
    morning: amTimeSlots,
    afternoon: pmTimeSlots,
  };
};

export const getFormattedTimeSlots = (data) => {
  return data.map((slot) => ({
    label: moment(slot.time_slot, "YYYY-MM-DD hh:mm:ss A").format("h:mm a"), // Specify format for consistency
    value: slot.time_slot,
  }));
};

export function findTourData(availableSlots, key) {
  for (let obj of availableSlots) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      return obj[key];
    }
  }

  return null;
}

export function mergeData(newData, oldData) {
  // Define the set of keys that should be merged
  const keysToMerge = new Set(["live_video_tour", "in_person_tour", "self_guided_tour"]);
  const merged = {};

  // Iterate over oldData and store relevant keys in the merged object
  oldData.forEach((obj) => {
    Object.keys(obj).forEach((key) => {
      if (keysToMerge.has(key)) {
        merged[key] = obj[key];
      }
    });
  });

  // Iterate over newData and override relevant keys in the merged object
  newData.forEach((obj) => {
    Object.keys(obj).forEach((key) => {
      if (keysToMerge.has(key)) {
        merged[key] = obj[key];
      }
    });
  });

  // Convert the merged object back to an array of objects
  return Object.entries(merged).map(([key, value]) => ({ [key]: value }));
}

export const handleTourResponse = (res, isAvailableDates = false, tourType = "", time) => {
  const state = store.getState();
  res = res ?? [];
  const availableSlots = isAvailableDates ? res : res.data?.response?.available_slots || res.data?.response?.booking?.available_slots || [];
  const slotData = isAvailableDates ? res[0][tourType] : findTourData(availableSlots, tourType || res.data?.response?.context[0]?.tourType);
  const appSSID = state.window.appSSID || "";
  const propertyId = state.property.property_id || "";
  const oldAllData = state.scheduleTour.allData || [];

  if (!slotData) {
    store.dispatch(setAvailableSlots(null));
    store.dispatch(setSlotsLoading(false));

    const requestOption = {
      tag: "NO_SAT_SLOT",
      metric: "Surprise",
      propertyId: propertyId,
      sessionId: appSSID,

      appSubsection: "No slot in SAT",
    };
    createEventSignal(requestOption);

    return;
  }

  const dates = extractUniqueDates(slotData);
  const firstDate = dates[0];
  const firstTimeSlots = filterByDate(slotData, firstDate);
  let selectedTimeSlot = firstTimeSlots[0].time_slot;

  if (time) {
    const tSlot = findTimeSlot(time, firstTimeSlots);

    if (tSlot) {
      selectedTimeSlot = tSlot;
    }
  }

  const properTimeSlots = getAmPmSlotsSeparated(getFormattedTimeSlots(firstTimeSlots));
  const mergedNewOldData = mergeData(oldAllData, isAvailableDates ? res : availableSlots);

  store.dispatch(setAllData(mergedNewOldData));
  store.dispatch(setAvailableDates(dates));
  store.dispatch(setAvailableSlots({ date: dates, time: properTimeSlots }));
  store.dispatch(setSelectedOptions({ tourType: tourType || res.data.context[0].tourType, date: firstDate, time: selectedTimeSlot }));

  if (!isAvailableDates) {
    const date = res.data.context[0].preferredDate || "";

    const time = res.data.context[0].preferredTime
      ? moment(`${date} ${res.data.context[0].preferredTime}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD h:mm:ss A")
      : "";
    store.dispatch(setLabelItems({ appointment_type: tourType || "", date, time }));
  } else {
    store.dispatch(setSlotsLoading(false));
    store.dispatch(setFilterDates(true));
  }

  store.dispatch(setShouldFetchSlots(false));
};

export const getFormattedDate = (date) => {
  if (date.includes("From Today") || date.includes("From Tomorrow")) {
    return date.replace("From", "");
  }

  if (date.includes("From")) {
    const options = { year: "numeric", month: "short", day: "numeric" };
    const formattedDate = new Date(date.replace("From ", "").replace(/-/g, "/")).toLocaleDateString("en-US", options); // Replace hyphens to ensure compatibility

    return formattedDate;
  }

  return date;
};

export function getLastConversations(messages, maxUserMessagesPerConversation = 5) {
  let userMessageCount = 0;
  let totalMessagesCount = 0;

  for (let i = messages.length - 1; i >= 0; i--) {
    const message = messages[i];
    totalMessagesCount++;

    if (message.speaker === "user") {
      userMessageCount++;
    }

    if (userMessageCount >= maxUserMessagesPerConversation) {
      return messages.slice(-totalMessagesCount);
    }
  }

  return messages.slice(-totalMessagesCount);
}

export const getLocalStorageContextDetails = (propertyId) => {
  try {
    const storedContext = localStorage.getItem(`${propertyId}-context`);
    const parsedContext = storedContext ? JSON.parse(storedContext) || [] : [];
    const firstItem = parsedContext?.[0] || {};

    return {
      contextList: parsedContext,
      currentTourAction: firstItem?.tourAction,
      currentBooking: firstItem?.booking_found,
      currentRequiredInfo: firstItem?.required_info,
      currentSubject: firstItem?.subject,
      currentNeedInfo: firstItem?.need_info,
    };
  } catch (error) {
    console.error(`Failed to parse localStorage context for propertyId: ${propertyId}`, error);

    return {
      contextList: [],
      currentTourAction: undefined,
      currentBooking: undefined,
      currentRequiredInfo: undefined,
      currentSubject: undefined,
      currentNeedInfo: undefined,
    };
  }
};

export const formatCommonDates = (date, format = "MMM DD, YYYY") => {
  if (!date) {
    return null;
  }

  let parsedDate = null;

  // Handle cases where date contains "/"
  if (date.includes("/")) {
    const parts = date.split("/");

    parsedDate = parseInt(parts[0], 10) > 12 ? moment(date, "DD/MM/YYYY", true) : moment(date, "MM/DD/YYYY", true);
  } else {
    // General case: Try all formats
    const formats = [
      "YYYY-MM-DD",
      "DD-MM-YYYY",
      "MM-DD-YYYY",
      "DD MMM YYYY",
      "DD MMMM YYYY",
      "MMM DD, YYYY",
      "MMMM DD, YYYY",
      "YYYY/MM/DD",
      "YYYY.MM.DD",
      "DD.MM.YYYY",
      "MM.DD.YYYY",
      "DD MMM, YYYY",
      "MMMM D, YYYY",
      "D MMM YYYY",
      "D MMMM YYYY",
      "YYYY MMM DD",
      "YYYY MMMM DD",
      "DD MMM YY",
      "DD-MM-YY",
      "DD/MM/YY",
      "DD.MM.YY",
    ];
    parsedDate = moment(date, formats, true);
  }

  return parsedDate.isValid() ? parsedDate.format(format) : null;
};

export function getUrlParam(key) {
  const urlParams = new URLSearchParams(window.location.search);

  return urlParams.get(key);
}

// Move specified tour type element as the first element of array
export const moveTourTypeToFront = (allData, clickedTourType) => {
  const tourTypeItem = allData.find((item) => item[clickedTourType]); // Find the matching item

  if (!tourTypeItem) {
    return allData; // If not found, return the array as is
  }

  // Remove the tourTypeItem from the array and put it at the front
  const filteredData = allData.filter((item) => item !== tourTypeItem);

  return [tourTypeItem, ...filteredData]; // Put the found item first and concatenate the rest
};

export const updateConversationEntryId = (entryId, email) => {
  store.dispatch(setEntryId(entryId));
  store.dispatch(setEmail(email));

  updateHayleyConversation(entryId);
};

// If it's a JSON array string, it extracts the first value.
export const getFirstBedroomTypeQuery = (queryParams) => {
  if (!queryParams) {
    return "";
  }

  const urlParams = new URLSearchParams(queryParams);
  const rawBedroomType = urlParams.get("bedroom_type");

  let bedroomType = rawBedroomType;

  try {
    if (rawBedroomType?.startsWith("[")) {
      bedroomType = JSON.parse(rawBedroomType)[0];
    }
  } catch {
    // Fail silently and use the original value
  }

  urlParams.delete("bedroom_type");

  if (bedroomType) {
    urlParams.append("bedroom_type", bedroomType);
  }

  return `?${urlParams.toString()}`;
};

export const handleAMAResponse = (res, skipLanguageCheck = false) => {
  const state = store.getState();
  const isPerformanceReport = state.replies.isPerformanceReport;
  const labelItems = state.params.label;
  const isVideoTourEnabled = state.property.live_video_tour;
  const isInPersonTourEnabled = state.property.in_person_tour;
  const isSelfGuidedTourEnabled = state.property.self_guided_tour;
  const isPriceFilter = state.property.isPriceFilter;
  const propertyId = state.property.property_id || "";
  const SSID = state.window.appSSID || "";
  const apiKey = state.property.api_key || "";
  const isMultiLanguageSupported = !!state.property.isMultiLanguage;

  async function getScheduleStatus() {
    const url = `${process.env.REACT_APP_API_BASE_URL}/apartments/schedule_status?property_id=${propertyId}&api_key=${apiKey}&entry_session_id=${SSID}`;

    try {
      const response = await axios.get(url);

      return response.data;
    } catch (error) {
      console.error("Error fetching schedule status:", error);
      throw error;
    }
  }

  createItemRecord(propertyId, SSID, "faqs");

  const LANG_KEYS = {
    es: "sp",
    en: "en",
  };

  const lang = LANG_KEYS[res?.data?.language];

  if (lang && lang !== i18n.language && !skipLanguageCheck && isMultiLanguageSupported) {
    const isSpanish = lang === "sp";

    if (isSpanish) {
      store.dispatch(
        removeAndAddMessages([
          {
            message: "I detect Spanish in your message. Would you like to continue in Spanish?",
            speaker: "bot",
            createdAt: new Date().toISOString(),
          },
        ])
      );

      store.dispatch(setReplies(LANG_CHANGE_REPLIES));
      store.dispatch(setIsDisabled(false));
      store.dispatch(setAMAReply(null));
      store.dispatch(setAMAResponse(res));

      return;
    }
  }

  let resSubject = res?.data?.subject;
  const resContext = res?.data?.context?.[0];
  const availableSlots = res?.data?.response?.available_slots || res?.data?.response?.booking?.available_slots || [];

  let imageUrls;

  if (resSubject === "photos") {
    imageUrls = res?.data?.images_url || {};
  } else {
    imageUrls = res?.data?.images_url?.length > 0 ? JSON.parse(res?.data?.images_url) : [];
  }

  if (resSubject === "schedule a tour") {
    if (availableSlots && Array.isArray(availableSlots) && availableSlots.length > 0) {
      const tourType = resContext?.tourType || APPOINTMENT_TYPES[res?.data?.response?.booking?.booking?.appointmentType] || labelItems.appointment_type;

      const tourOptions = {
        in_person_tour: isInPersonTourEnabled,
        live_video_tour: isVideoTourEnabled,
        self_guided_tour: isSelfGuidedTourEnabled,
      };

      setTimeout(() => {
        for (const [appointmentType, isEnabled] of Object.entries(tourOptions)) {
          if (isEnabled) {
            handleTourResponse(res, false, tourType || appointmentType);
            break;
          }
        }
      }, 0);

      store.dispatch(setShouldFetchSlots(false));
    }

    const bookingDetails = res?.data?.response?.booking?.booking ?? {};

    if (resContext?.booking_found && !resContext?.required_info) {
      if (bookingDetails && Object.keys(bookingDetails).length > 0) {
        localStorage.setItem(`${propertyId}-booking_details`, JSON.stringify(bookingDetails));
        localStorage.setItem(`${propertyId}-bookingId`, bookingDetails.id);
      }
    }

    store.dispatch(setTourAction(resContext?.tourAction));
  }

  if (resSubject === "unit availability") {
    const payloadT = { bedroom_type: `${resContext?.bedroomPreference}` };

    if (resContext?.priceRange) {
      payloadT["price"] = resContext?.priceRange.split("-");
    }

    if (resContext?.desiredMoveInDate) {
      payloadT["desired_move_in"] = resContext?.desiredMoveInDate;
    }

    localStorage.setItem(`${propertyId}-context`, JSON.stringify([resContext]));
    store.dispatch(setLabelItems(payloadT));
  }

  const linksHandle = resSubject === "schedule a tour" || resSubject === "unit availability" ? res.data.response?.description : res.data.response;

  let isUnitAvailable = resContext?.bedroomPreference && resContext?.desiredMoveInDate && res.data?.response?.available_slots?.floor_plans?.length > 0;

  if (isPriceFilter) {
    isUnitAvailable = isUnitAvailable && resContext?.priceRange;
  }

  // If intent is "apartment_inquiry" then don't ask follow ups, show the units straight up
  if (resContext?.intent === "apartment_inquiry") {
    isUnitAvailable = true;
  }

  if (isUnitAvailable) {
    store.dispatch(setSearchResult(res?.data?.search_result || false));
  }

  const isContact = resSubject.includes("contact") || resSubject.includes("contact_summary");
  const isAgentHandoff = res?.data?.agent_handoff?.agent_handoff_triggered;

  if (resSubject && (resSubject.includes("links") || resSubject.includes("location"))) {
    const responseMessage = res?.data?.response || "";
    const hasShortUrl = /maps\.app\.goo\.gl|goo\.gl\/(maps|[A-Za-z0-9]+)/.test(responseMessage);
    const hasRegularMapsUrl = responseMessage.includes("google.com/maps") && !hasShortUrl;

    if (hasRegularMapsUrl) {
      resSubject = "embed_map_view";
    }
  }

  const agentHandoff = res?.data?.agent_handoff ?? {};

  const feeSummaryFlag = resContext?.spf?.fee_utilities_summary || false;
  const feeSummaryResponse = resContext?.fee_summary_response || null;

  if (optionsBySubject[resSubject]) {
    store.dispatch(
      setAMAReply({
        description: res.data.response?.description ?? null,
        message: linksHandle,
        id: res.data.message_id,
        summary: res.data.neighborhood_summary,
        neighborhood: res.data.context?.[0] ?? {},
        speaker: "faqBot",
        subject: resSubject,
        context: res.data.context,
        createdAt: new Date(),
        available_tourTypes: res.data?.available_tourTypes,
        not_available: res.data.response?.available_slots?.filter_excluded,
        follow_up: res.data?.follow_up,
        availableUnits: isUnitAvailable
          ? {
              ...res.data.response?.available_slots,
              fee_disclaimer: res.data.response?.available_slots?.fee_disclaimer,
            }
          : null,
        images: imageUrls,
        photos: imageUrls,
        fee_utilities_summary: feeSummaryFlag,
        fee_summary_response: feeSummaryResponse,
      })
    );
  } else if (isAgentHandoff) {
    if (agentHandoff?.need_info === "entry_id") {
      localStorage.setItem(`${propertyId}-agentHandOff`, JSON.stringify(agentHandoff));

      store.dispatch(setIsDisabled(false));

      store.dispatch(
        removeAndAddMessages([
          {
            message: t("leasing_agent_will_contact"),
            speaker: "bot",
            createdAt: new Date().toISOString(),
          },
        ])
      );

      let rep = {
        checkStorage: true,
        disableResetBox: false,
        options: FORM_4_CONTACT_US_OPTIONS,
        optionsType: "Form4ContactUs",
        title: "Enter First Name and Last Name",
        renderType: "multiInputView",
      };

      store.dispatch(setReplies(rep));
    } else {
      store.dispatch(
        removeAndAddMessages([
          {
            message: getLocalizedText(res?.data?.response) || "Leasing agent will contact you soon.",
            id: res.data.message_id,
            speaker: "faqBot",
            createdAt: new Date(),
          },
        ])
      );

      store.dispatch(setReplies(INITIAL_REPLIES));
      store.dispatch(setIsDisabled(false));
    }
  } else if (isContact) {
    const entryId = localStorage.getItem(`${propertyId}-entry_id`);

    if (entryId) {
      store.dispatch(
        removeAndAddMessages([
          {
            message: t("already_filled_contact_form"),
            id: res.data.message_id,
            speaker: "faqBot",
            createdAt: new Date(),
          },
        ])
      );

      store.dispatch(setReplies(INITIAL_REPLIES));
      store.dispatch(setIsDisabled(false));
    } else {
      store.dispatch(setIsDisabled(false));

      store.dispatch(
        removeAndAddMessages([
          {
            message: t("leasing_agent_will_contact"),
            speaker: "bot",
            createdAt: new Date().toISOString(),
          },
        ])
      );

      let rep = {
        checkStorage: true,
        disableResetBox: false,
        options: FORM_4_CONTACT_US_OPTIONS,
        optionsType: "Form4ContactUs",
        title: "Enter First Name and Last Name",
        renderType: "multiInputView",
      };

      store.dispatch(setReplies(rep));
    }
  } else {
    store.dispatch(
      removeAndAddMessages([
        {
          message: linksHandle,
          id: res.data.message_id,
          summary: res.data.neighborhood_summary,
          neighborhood: res.data.context?.[0] ?? {},
          speaker: "faqBot",
          subject: resSubject,
          createdAt: new Date(),
          available_tourTypes: res.data.available_tourTypes,
          follow_up: res.data?.follow_up,
          images: imageUrls,
          fee_utilities_summary: feeSummaryFlag,
          fee_summary_response: feeSummaryResponse,
        },
      ])
    );

    store.dispatch(setIsDisabled(false));
  }

  if (res?.data?.performance_logger?.[0]?.table && isPerformanceReport && reportIds.includes(propertyId)) {
    store.dispatch(addNewMessage([{ message: "performanceReportText", speaker: "bot", createdAt: new Date() }]));
    store.dispatch(addNewMessage([{ key: "report", speaker: "comp", compData: res?.data?.performance_logger?.[0]?.table, createdAt: new Date() }]));
  }

  // If subject is an array then take first element
  const subject = Array.isArray(resSubject) ? resSubject[0] : resSubject;

  // Increment only if `subject` is NOT in `FOLLOW_UP_KEYS`
  let hasFollowUpKey = FOLLOW_UP_KEYS.includes(subject);
  hasFollowUpKey = true; // disable follow up temporarily
  let storedCount = localStorage.getItem(`${propertyId}-follow-up-count`);

  if (!hasFollowUpKey) {
    storedCount = (parseInt(storedCount) || 0) + 1;
    localStorage.setItem(`${propertyId}-follow-up-count`, storedCount);
  }

  if (parseInt(storedCount) >= 3 && !ALL_CHAT_SUBJECTS.filter((o) => o !== "schedule").includes(subject)) {
    getScheduleStatus().then((alreadyScheduled) => {
      if (alreadyScheduled === false) {
        localStorage.setItem(`${propertyId}-follow-up-count`, 0);

        store.dispatch(
          addNewMessage([
            {
              message: "wouldYouSchedule",
              id: res.data.message_id,
              speaker: "faqBot",
              subject: "schedule",
              createdAt: new Date(),
              follow_up: res.data.follow_up,
            },
          ])
        );
      }
    });
  }
};

export function getLocalizedText(response) {
  // Case 1: Already a string → return directly
  if (typeof response === "string") {
    return response;
  }

  // Case 2: Object with translations
  if (response && typeof response === "object") {
    const hasEn = Object.prototype.hasOwnProperty.call(response, "en");
    const hasEs = Object.prototype.hasOwnProperty.call(response, "es");

    if (hasEn && hasEs) {
      // Normalize i18n language to match API keys
      const currentLang = i18n.language === "sp" ? "es" : "en";

      return response[currentLang] || response.en; // fallback to English
    }
  }

  // Case 3: Unexpected format → return as-is
  return response;
}

export const processDisclaimerHtml = (htmlString) => {
  if (!htmlString) {
    return "";
  }

  // Use a temporary DOM element to parse the HTML string.
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;

  // Find all anchor tags within the parsed HTML.
  const links = tempDiv.querySelectorAll("a");

  // Iterate over each link and add the target attribute if it's missing.
  links.forEach((link) => {
    // Check if the link already has a 'target' attribute to avoid overwriting.
    if (!link.hasAttribute("target")) {
      link.setAttribute("target", "_blank");
    }
  });

  // Return the modified HTML string.
  return tempDiv.innerHTML;
};

// Utility function to convert URLs in text to clickable links
export const linkifyText = (text) => {
  if (!text || typeof text !== "string") {
    return text;
  }

  const urlRegex = /(https?:\/\/[^\s]+)/g;

  return text.replace(urlRegex, (url) => {
    let cleanUrl = url;
    let trailingPunctuation = "";

    const lastChar = url.slice(-1);

    if ([".", ",", "!", "?", ";", ":"].includes(lastChar)) {
      cleanUrl = url.slice(0, -1);
      trailingPunctuation = lastChar;
    }

    return `<a href="${cleanUrl}" target="_blank" rel="noopener noreferrer" style="color: #26BBED; text-decoration: underline;">${cleanUrl}</a>${trailingPunctuation}`;
  });
};

export const hasDateInText = (text) => {
  if (!text || typeof text !== "string" || text.trim() === "") {
    return false;
  }

  const str = text.trim();

  const regexPatterns = [
    // Month name formats: "Nov 20, 2025", "November 20 2025"
    /\b(?:Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:t(?:ember)?)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?)\.?\s+\d{1,2}(?:,)?\s*\d{2,4}\b/gi,

    // Numeric year-first formats: "2025-11-20", "2025/11/20"
    /\b\d{4}[/-]\d{1,2}[/-]\d{1,2}\b/g,

    // Numeric day-first formats: "20-11-2025", "20/11/25"
    /\b\d{1,2}[/-]\d{1,2}[/-]\d{2,4}\b/g,

    // Textual + numeric hybrids like "20th Nov 2025"
    /\b\d{1,2}(?:st|nd|rd|th)?\s+(?:Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:t(?:ember)?)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?),?\s*\d{2,4}\b/gi,
  ];

  for (const regex of regexPatterns) {
    const match = str.match(regex);

    if (match && match.length > 0) {
      const dateCandidate = match[0];

      if (
        moment(dateCandidate, moment.ISO_8601, true).isValid() ||
        moment(dateCandidate, ["MM/DD/YYYY", "DD/MM/YYYY", "YYYY-MM-DD", "MMM D, YYYY", "MMMM D, YYYY"], true).isValid()
      ) {
        return true;
      }

      return true;
    }
  }

  return false;
};

export const hexToRgba = (hex, opacity) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  if (result) {
    const r = parseInt(result[1], 16);
    const g = parseInt(result[2], 16);
    const b = parseInt(result[3], 16);

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  return hex;
};
